import BaseLayout from "@layout/base-layout";
import { inject, observer } from "mobx-react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";

const TermsPage = inject("CoreStore")(
  observer((props) => {
    return (
      <>
        <Head>
          <link
            rel="canonical"
            href={`${process.env.NEXT_PUBLIC_SITE_ADDRESS}content/protection/terms`}
          />
        </Head>

        <div className={"container"}>
          {props.CoreStore.lang == "en" ? (
            <main className="w-full">
              <h1 className=" mt-14 w-full px-0 text-4xl font-bold mb-14 ">
                Terms {"&"} Conditions
              </h1>
              <div className=" grid w-full  grid-cols-1 leading-10 items-start justify-items-center gap-y-4 px-4  md:px-0 lg:grid-cols-[1fr_2fr]">
                <aside className="flex sticky w-full flex-col items-start justify-center border-[#C4C4C4] pr-4 lg:border-r">
                  <p className="text-3xl font-bold mb-10 text-[#FF9F1C]">
                    Table of Contents
                  </p>
                  <ul className="text-sm space-y-2 font-medium leading-7 ">
                    <li>
                      <a className={"capitalize text-base"} href="">
                        A.General Terms and Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term1"
                        className={"capitalize pl-0 block mb-4 text-gray-700"}
                      >
                        1. Scope of application, exclusion of deviating terms
                        and conditions of business
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term2"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        2. subject matter of the contract
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term3"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        3. conclusion of contract with the provider
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term4"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        4. cooperation obligations of the provider
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term5"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        5. granting of rights of use
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term6"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        6. Availability of the Website
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term7"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        7. Term and termination of the user contract
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term8"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        8. limitations of liability of moverii
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term9"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        9. indemnification
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term10"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        10. links to third party websites, optional tools.
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term11"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        11. ratings, feedback
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term12"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        12. international journeys
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term13"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        13. exclusion of foreign general terms and conditions,
                        applicable law, place of jurisdiction, place of
                        performance
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term14"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        14. Amendment of these GTCs
                      </a>
                    </li>
                    <li>
                      <a href="#termB" className={"capitalize text-base"}>
                        B. Special conditions for the use of the website
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term15"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        15. setting a sports offer, minimum content, change
                        procedure
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term16"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        16. booking process, conclusion of the sports contract,
                        moverii as messenger, no insurance
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term17"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        17. booking price and moverii fee, circumvention
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term18"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        18. payment modalities
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term19"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        19. best price guarantee
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term20"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        20.withdrawal from the sports contract and cancellation
                        conditions
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term21"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        21.symbolic images, no control user data, no claim
                        settlement, reference to consumer rights, taxation
                      </a>
                    </li>

                    <li>
                      <a href="#termC" className={"capitalize  text-base"}>
                        C. Cancellation policy
                      </a>
                    </li>
                  </ul>
                </aside>
                <section className="flex w-full leading-10 flex-col items-start  justify-start lg:pl-10">
                  <article
                    id="term1"
                    className="flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl  mb-3 capitalize font-bold leading-10">
                      1. Scope of application, exclusion of deviating terms and
                      conditions of business
                    </p>
                    <p className="text-sm leading-8 font-normal leading-6">
                      1.1 The following general terms and conditions
                      (hereinafter "GTC") apply to the service offer operated by
                      Adrian Helbig, Daniel Helbig GbR, Schloßstraße 4, 53115
                      Bonn, Germany (hereinafter "moverii"), which is provided
                      under the domain moverii.de (hereinafter "website").
                    </p>
                    <p className="mb-0 leading-8 text-sm font-normal leading-6">
                      1.2 In addition, the privacy policy (available under this
                      link) applies.
                    </p>
                    <p className="text-sm leading-8 font-normal ">
                      1.3 The version of the GTC valid at the time of the
                      conclusion of the contract is authoritative.
                    </p>
                    <div className="my-3 leading-8  rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm  leading-6 font-medium leading-8">
                        In the following you will find the GTCs for our website.
                        In these boxes we give you a small and understandable
                        summary in each case. The summary is for general
                        orientation and is not legally binding.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term2"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold capitalize mb-3 leading-10">
                      2. subject matter of the contract
                    </p>
                    <p className="text-sm font-normal leading-8">
                      2.1. moverii operates the website on which users
                      (hereinafter referred to as "User") can use the offer
                      available on the website, within the framework provided
                      and in accordance with these GTC. The use of the Website
                      may trigger costs and fees (see clause 17).
                    </p>
                    <p className="text-sm font-normal leading-8">
                      2.2 The Website offers entrepreneurs, legal entities,
                      partnerships and natural persons the opportunity to offer
                      services and travel services from the areas of sports,
                      fitness and leisure (hereinafter "Sports Offer") within
                      the framework of the provisions of these GTC (hereinafter
                      "Provider"). The website also offers natural persons who
                      are not acting for the purpose of their commercial or
                      independent professional activity, so-called consumers,
                      the opportunity to book the sports offers posted by the
                      providers within the framework of the provisions of these
                      GTC (hereinafter "Customer").
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Providers of sports and active trips can offer their
                        offers through our platform. We ourselves do not
                        organize journeys. If you as a customer book a sports
                        trip via our platform, an independent contract with the
                        travel provider is concluded.
                      </p>
                    </div>
                    <p className="text-sm font-normal leading-8">
                      2.3 The legally binding booking of sports offers between a
                      provider and a customer (hereinafter "sports contract") is
                      explained in more detail in section B of these GTC and is
                      subject to a fee (see regulation in section 17).
                    </p>

                    <p className="text-sm font-normal leading-8">
                      2.4. moverii itself does not offer sports offers for
                      booking, but makes the website available to users for use
                      and acts as an intermediary between provider and customer.
                      moverii does not become a party to the sports contract.
                      Users therefore have no claim against moverii for the
                      conclusion of a sports contract. moverii is neither
                      involved in the content of the sports offers, nor in the
                      execution of the sports contracts themselves. moverii has
                      no influence on the content of the sports offers or on the
                      condition, legality, suitability or quality of the sports
                      offers. Furthermore, the content published on the website
                      by users is generally not checked by moverii and does not
                      represent any information or opinion of moverii.
                    </p>
                  </article>

                  <article
                    id="term3"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      3. conclusion of contract with the provider
                    </p>
                    <p className="text-sm font-normal leading-8">
                      moverii submits to the provider in written or verbal
                      communication a binding offer to conclude a contract of
                      use for the use of the website including the amount and
                      scope of the commission agreement (hereinafter "contract
                      of use"). By confirming the offer (hereinafter
                      "confirmation"), the provider accepts the offer of moverii
                      and a usage agreement is concluded according to the terms
                      and conditions set forth herein as well as additional
                      terms and conditions set forth in writing, typically in
                      email communication. The initiation, continuation or
                      completion of an advertisement of the provider on the
                      platform is also considered as confirmation, regardless of
                      whether this advertisement was created by the provider or
                      by moverii. If the confirmation is not accepted within 4
                      weeks from receipt of the offer by the provider, no
                      contract between moverii and the provider is concluded.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Suppliers of sports and active trips can offer their
                        offers through our platform. We ourselves do not
                        organize journeys. If you as a customer book a sports
                        trip through our platform, an independent contract with
                        the travel provider is concluded.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term4"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      4. cooperation obligations of the provider
                    </p>
                    <p className="text-sm font-normal leading-8">
                      4.1 The success or failure of the cooperation between
                      moverii and the provider also depends decisively on
                      whether and to what extent the provider cooperates within
                      the scope of his capacity in the realization of the user
                      contract. The provider is therefore obliged in particular
                    </p>
                    <p className="text-sm pl-4 font-normal leading-8">
                      a. to provide moverii and its personnel and subcontractors
                      employed for the realization of the user contract with all
                      necessary information and disclosures. In addition, the
                      provider shall provide moverii with documents, files,
                      templates and other information necessary for the
                      implementation of the setting of the sports offers without
                      being asked, as early as possible or in time for the
                      fulfillment of the contract and free of rights of third
                      parties.
                    </p>
                    <p className="text-sm pl-4 font-normal leading-8">
                      b. The Provider shall designate to moverii a competent
                      contact person who is authorized to make legally effective
                      declarations on behalf of the Provider.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        We always keep the journeys and offers on our platform
                        up to date. In order to be able to do so, our partners
                        commit themselves to support us with information
                        accordingly.
                      </p>
                    </div>

                    <p className="text-sm font-normal leading-8">
                      4.2 As long as the provider fails to do so or fails to do
                      so properly, and this results in moverii not being able to
                      fulfill its obligations, no default shall occur on the
                      part of moverii.
                    </p>
                  </article>

                  <article
                    id="term5"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      5. granting of rights of use
                    </p>
                    <p className="text-sm font-normal leading-8">
                      5.1. moverii grants the User the locally unrestricted,
                      revocable, non-exclusive, non-sublicensable and
                      non-transferable right to use the Website solely for the
                      purpose of using the Website to the extent and in
                      accordance with the GTC for the duration of the User
                      Agreement. The ownership and copyright of the Website
                      shall remain exclusively with moverii.
                    </p>
                    <p className="text-sm pl-4 font-normal leading-8">
                      5.2 The provider grants moverii the simple, spatially and
                      temporally unrestricted, worldwide, transferable and
                      sublicensable right to use all content (e.g. logos,
                      images, videos, texts) (hereinafter "content") provided by
                      him for the website (hereinafter "license"). In this
                      context, everything that has been sent electronically or
                      by post to moverii or has been downloaded by moverii with
                      the consent of the Provider on publicly accessible domains
                      or internet pages referred to by the Provider, including
                      the Provider's social media pages, shall be deemed to have
                      been made available. This includes in particular the right
                      to reproduce, use, operate, copy, publicly perform or
                      display, distribute, modify, translate and create
                      derivative versions as well as the right to edit. moverii
                      is in particular entitled to technically edit, prepare and
                      adapt the content in such a way that it can also be
                      displayed on mobile receiving devices or in software
                      applications of third parties.
                    </p>
                    <p className="text-sm pl-4 font-normal leading-8">
                      b. The Provider shall designate to moverii a competent
                      contact person who is authorized to make legally effective
                      declarations on behalf of the Provider.
                    </p>
                    <div className="mt-6rounded-[1.25g-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        If providers register with us, we may use images and
                        videos of the journeys to market the journeys. When a
                        provider terminates the user agreement, we are no longer
                        allowed to do so. We will then try to delete all
                        material, but we cannot guarantee this.
                      </p>
                    </div>

                    <p className="text-sm font-normal leading-8">
                      5.3 The license terminates when the provider requests
                      moverii to delete its content or sports listings; unless
                      the content has been shared with other users and they have
                      not deleted the content. As part of such termination,
                      moverii shall endeavor, but shall not be obligated, to
                      delete or protect from reproduction any Content that has
                      already been posted.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      5.4 The license also includes the right to use and publish
                      the information for promotional reasons on other
                      platforms, for example on social networks such as Facebook
                      or Instagram. These platforms usually have their own terms
                      of use and in turn expect certain rights of use. By
                      transferring the license, the provider agrees that the
                      textual and visual information will be published on these
                      networks under the respective applicable terms of use. In
                      case the provider deletes his account and/or terminates
                      his contract, any rights of use already granted shall
                      remain with moverii or its partner companies or the
                      respective third party providers.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      5.5 The provider guarantees that he is the owner of the
                      transferred rights and that it is possible for him to
                      effectively grant the rights mentioned in clause 5.2. The
                      Provider also guarantees that the content created by him
                      does not violate any rights of third parties, in
                      particular trademark rights, competition rights,
                      copyrights, property rights or personal rights. In case of
                      such infringement moverii reserves the right to claim all
                      incurred damages from the provider.
                    </p>
                  </article>

                  <article
                    id="term6"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      6. Availability of the Website
                    </p>
                    <p className="text-sm font-normal leading-8">
                      moverii offers the Website subject to availability.
                      moverii endeavors to keep the Website accessible at all
                      times. Due to maintenance work, further development or
                      disruptions, the possibilities of use may be limited or
                      temporarily interrupted. This may also result in loss of
                      data under certain circumstances.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        We try to ensure that our site is always accessible.
                        However, something could go wrong from time to time.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term7"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      7. Term and termination of the user contract
                    </p>
                    <p className="text-sm font-normal leading-8">
                      7.1 The user contract with the provider is concluded for
                      an indefinite period.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      7.2. moverii or the Provider may terminate the User
                      Agreement, subject to the following sentence, with a
                      notice period of 14 days. However, if the Provider has
                      concluded a sports contract prior to the termination, the
                      termination shall not become effective until the sports
                      contract has been fully performed, cancelled or otherwise
                      terminated. An e-mail to [team@moverii.de] or a written
                      notice to moverii shall suffice for the notice of
                      termination.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      7.3 The right to terminate for cause remains unaffected.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        The user contract with providers can be terminated by
                        either party with a notice period of 14 days. This does
                        not affect existing bookings. These must be carried out
                        normally.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term8"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      8. limitations of liability of moverii
                    </p>
                    <p className="text-sm font-normal leading-8">
                      8.1 Subject to the further provisions of this clause 8,
                      moverii shall only be liable if and to the extent moverii,
                      its legal representatives, officers, employees or other
                      vicarious agents are guilty of intent or gross negligence.
                      Interaction between users, providers and customers on the
                      platform is at their own risk. Users agree that moverii is
                      not liable for any obligations or charges arising from
                      such interaction. Nevertheless, all users undertake to
                      interact within the platform within the framework of
                      decency and good morals. Likewise, moverii shall not be
                      liable for the conduct of users, providers or customers in
                      the execution of a sports contract.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      8.2 In case of default of moverii or impossibility of
                      performance for which moverii is responsible, as well as
                      in case of breach of essential contractual obligations
                      (so-called cardinal obligations), moverii shall, however,
                      be liable for any own culpable conduct or that of its
                      legal representatives, officers, employees or other
                      vicarious agents. In this context, essential contractual
                      obligations are defined in the abstract as obligations
                      whose fulfillment makes the proper performance of the
                      contract possible in the first place and on whose
                      compliance the user may regularly rely.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      7.3 The right to terminate for cause remains unaffected.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        To keep things fair, we are only liable if we were
                        grossly negligent. We try to ensure that no damage
                        occurs before or during a sports trip, but we cannot
                        guarantee this. In the event of damage occurring, we
                        will try to mediate and resolve the problem to
                        everyone's satisfaction. However, the provider or the
                        user is liable for the damages.
                      </p>
                    </div>
                    <p className="text-sm font-normal leading-8">
                      8.3 Except in case of intent or gross negligence by
                      moverii, its legal representatives, officers, employees or
                      other vicarious agents, moverii's liability shall be
                      limited to the amount of damages typically foreseeable at
                      the time of the conclusion of the contract.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      8.4 The exclusions and limitations of liability set forth
                      in clauses 8.1 and 8.2 above shall not apply in the event
                      of the assumption of express warranties, in the event of
                      claims based on the absence of warranted characteristics
                      and for damages resulting from injury to life, body or
                      health as well as in the event of mandatory statutory
                      provisions. Furthermore, the limitations of liability set
                      forth in clause 8.2 shall not apply in the event of a
                      default by moverii to claims for interest on arrears, to
                      the lump sum for default pursuant to § 288 para. 5 BGB
                      (German Civil Code) as well as to compensation for the
                      damage caused by the default which is based on legal
                      costs.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      8.5 Claims under the Product Liability Act shall remain
                      unaffected by the provisions of this clause 8.
                    </p>
                  </article>

                  <article
                    id="term9"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      9. indemnification
                    </p>
                    <p className="text-sm font-normal leading-8">
                      The user indemnifies moverii from all claims of third
                      parties, in particular from claims due to copyright and
                      personal rights violations, which should be raised against
                      moverii in connection with the exercise of the contractual
                      rights, upon first request. The user is obliged to defend
                      also unfounded claims of third parties with regard to the
                      above mentioned rights. The User shall notify moverii
                      without undue delay of any infringement of the contractual
                      rights of which the User becomes aware. moverii shall be
                      entitled to take appropriate measures itself to defend
                      itself against claims by third parties or to pursue its
                      rights. Own measures of the user have to be coordinated
                      with moverii in advance. The indemnification also includes
                      the reimbursement of costs incurred or incurred by moverii
                      through a legal prosecution/defense. This shall not affect
                      any further claims for damages of moverii. As far as
                      moverii is responsible for the infringement itself, claims
                      against the user are excluded.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Of course we do our best! But surely you also understand
                        that we cannot check all content of all our partners. If
                        something is wrong with it, for example copyrights are
                        violated, then the provider is responsible for it.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term10"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      10. links to third party websites, optional tools.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      10.1 There may be links on the moverii Platform to third
                      party websites that are not affiliated with moverii.
                      moverii is not responsible for reviewing or evaluating the
                      content or accuracy of the content on those websites and
                      does not warrant or assume liability for any third party
                      materials or websites or for any other third party
                      materials, products or services.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      10.2. moverii shall not be liable for any damages arising
                      in connection with the purchase or use of goods, services,
                      resources, content or other transactions related to third
                      party websites. Users are encouraged to thoroughly review
                      the third party provider's terms of use, policies and
                      privacy policy prior to any transaction. Complaints,
                      claims, concerns or questions about third-party products
                      should be directed to them and not to moverii.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        There are links to other websites on our site, as there
                        are everywhere. We choose these carefully and use only
                        quality links. However, we cannot control all other
                        websites all the time and are not responsible for them.
                        So please check the terms of use of external sites
                        before using them.
                      </p>
                    </div>
                    <p className="text-sm font-normal leading-8">
                      10.3 The moverii platform may include third party tools
                      that are not necessary to use the platform, but are
                      optional. moverii has no ability to monitor or control
                      these services and assumes no liability for or in
                      connection with the use of optional third party tools. Use
                      is at your own risk and discretion. Users are encouraged
                      to thoroughly review the third party provider's terms of
                      use, policies and privacy policy prior to any use.
                    </p>
                  </article>

                  <article
                    id="term11"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      11. ratings, feedback
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Users have the possibility via forms on the moverii
                      website or on external websites or in direct written or
                      verbal communication to submit reviews for moverii or
                      individual listings as well as to submit ideas,
                      suggestions, recommendations or documents to improve the
                      platform (hereinafter "Feedback") to moverii. By
                      submitting such Feedback, users grant moverii an
                      irrevocable and perpetual right to use, publish and
                      reproduce such Feedback. There is no right to compensation
                      in any form for submitting this feedback.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        On our site, you may submit reviews for sports travel as
                        well as feedback about or for us. If you do so, we may
                        use this without restriction and do not have to
                        compensate you for it.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term12"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      12. international journeys
                    </p>
                    <p className="text-sm font-normal leading-8">
                      12.1 The sports offers that are presented on moverii
                      published advertisements sometimes take place in other
                      countries. This does not mean that traveling to the
                      respective countries and regions is risk-free, let alone
                      recommended on the part of moverii. moverii shall not be
                      liable for any loss or damage that arises or may arise
                      from journeys within the scope of sports contracts
                      concluded via the platform.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      12.2 Customers are solely responsible for ensuring that
                      they meet all requirements for entry into foreign
                      countries and that the documents required for the journey,
                      such as passports and visas, are valid and organized for
                      entry. moverii endeavors to advise customers of the
                      currently applicable travel advisories and restrictions
                      issued by the Department of State prior to fulfillment of
                      the sports contract, but does not guarantee this or the
                      accuracy of the information accessible about it. Customers
                      are themselves encouraged to thoroughly review all travel
                      bans, travel warnings, travel regulations and travel
                      advisories, from both the government of the country of
                      origin and the government of the country of destination
                      prior to entering into a sports contract.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        We all love journeys and travel a lot ourselves. So when
                        we notice that a part of the world is becoming unsafe,
                        we adjust our portfolio of offers. We also try to send
                        you links and information about your destination.
                        However, we can't always guarantee that and you have to
                        inform yourself about the destination and consider if
                        the destination is really suitable for you. Also, please
                        make sure that you have all the necessary travel
                        documents and vaccinations. We cannot be held
                        responsible for damage or loss during journeys.
                      </p>
                    </div>

                    <p className="text-sm font-normal leading-8">
                      12.3 For information on visas and passports, customers
                      should contact the relevant embassy or consulate for their
                      journeys. Requirements may change and customers should
                      always check that the information available is up to date
                      before entering into a sports contract. moverii accepts no
                      liability in the event that the airline or airport refuses
                      to allow customers to enter or is unable to allow
                      customers to enter a country due to lack of requirements
                      such as passport, visa or other documents that may be
                      required. This also applies to countries that may not be
                      the final destination but only stopovers and includes any
                      situation where an aircraft stops, even if the customer
                      remains on the aircraft or at the airport.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      12.4 Customers must consult their doctor to obtain the
                      necessary and recommended vaccinations for the journey. In
                      doing so, customers are responsible for taking all
                      recommended medications, obtaining required vaccinations,
                      meeting entry health requirements, and following all
                      medical advice given for the journey before beginning the
                      journey.
                    </p>
                  </article>

                  <article
                    id="term13"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      13. exclusion of foreign general terms and conditions,
                      applicable law, place of jurisdiction, place of
                      performance
                    </p>
                    <p className="text-sm font-normal leading-8">
                      13.1 The validity of general contractual or business terms
                      and conditions of the User is expressly excluded. This
                      shall also apply if moverii has not expressly objected to
                      the terms and conditions of the user and/or provides
                      services without objection.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      13.2 These terms and conditions and the contract of use
                      regulated therein are subject to the laws of the Federal
                      Republic of Germany under exclusion of the UN Convention
                      on Contracts for the International Sale of Goods.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      13.3 If the user is a merchant in the sense of commercial
                      law, a legal entity under public law or a special fund
                      under public law, the seat of moverii shall be the
                      exclusive place of jurisdiction for all disputes arising
                      from or in connection with the GTC. Otherwise the legal
                      places of jurisdiction shall apply.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      13.4 With respect to entrepreneurs in the sense of § 14
                      para. 1 BGB (German Civil Code), the place of performance
                      shall be the registered office of moverii.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Our GTCs shall apply. These GTCs are in accordance with
                        German law. The place of jurisdiction for legal disputes
                        is our registered office.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term14"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      14. Amendment of these GTCs
                    </p>
                    <p className="text-sm font-normal leading-8">
                      14.1 Amendments to these GTCs must be made in text form.
                      Subsidiary agreements do not exist.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      14.2. moverii reserves the right to change these terms and
                      conditions at any time without giving reasons, unless the
                      change is unreasonable for the user. moverii will notify
                      the user about changes to the terms and conditions
                      immediately by e-mail. If the User does not object to the
                      validity of the amended GTC within a period of four weeks
                      after receipt of the amended GTC, the amended GTC shall be
                      deemed to be accepted by the User. moverii shall
                      separately inform the User of this effect in the e-mail.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Everything changes. So it can also be that our terms and
                        conditions change. In this case we will let you know and
                        you can reject the new T&Cs.
                      </p>
                    </div>
                  </article>

                  <article
                    id="termB"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-4xl font-bold mb-3 capitalize leading-lg">
                      {" "}
                      B. Special conditions for the use of the website
                    </p>
                  </article>

                  <article
                    id="term15"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      15. setting a sports offer, minimum content, change
                      procedure
                    </p>
                    <p className="text-sm font-normal leading-8">
                      15.1. moverii creates for the provider on the website an
                      advertisement for the respective sports offer
                      (hereinafter: "advertisement"). For the creation of an
                      advertisement, mandatory information, in particular
                      regarding the type of sport, short description,
                      accommodation, environment, price, requirements for the
                      customer, fitness level of the customer and location of
                      the sports offer must be provided and confirmed by the
                      provider as well as visual materials must be provided
                      directly or indirectly to moverii for use according to
                      clause 5.2. This and other optional information can be
                      provided in written or verbal communication, in email
                      traffic, via external domains defined by moverii or
                      directly via the functions on the platform that have been
                      made available for this purpose.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      15.2 The Provider has the possibility to voluntarily
                      provide further data (e.g. qualifications and further
                      education). The provider is free to provide its own
                      contractual terms and conditions, which are included in
                      the sports contract, provided that they do not conflict
                      with the provisions of these GTC. In particular, the
                      provider is free to agree on cancellation and withdrawal
                      conditions.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      15.3. moverii endeavors, but is not obligated, to check or
                      verify the accuracy or completeness of information
                      provided by the provider. The obligation to revise,
                      regularly check and verify the accuracy of the information
                      in the advertisement is incumbent on the provider. The
                      information in the advertisement is decisive for the
                      content of the resulting sports contract.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      15.4 moverii reserves the right to amend, revise or adjust
                      materials and descriptions provided by the Provider before
                      or after publication of the Listing at its sole
                      discretion. moverii shall attempt to inform Providers of
                      any such changes in a timely manner. In addition, moverii
                      reserves the right to highlight profiles of Providers and
                      Listings within the Platform at its sole discretion.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Declaration text: Offers do not come from anywhere! In
                        order to be able to display offers, providers have to
                        provide certain information about the sports trip, for
                        example about the accommodation, the sports program, the
                        leisure activities or additional regulations. Some of
                        the information is required, some is optional. Of
                        course, we will help you in the creation of the offers
                        and will continuously optimize your offers. We will
                        inform you about relevant changes.
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Customers must be able to rely on the information in the
                        offer, so providers must always keep it up to date.
                        Suppliers can of course adjust their offers at any time,
                        but this does not apply retroactively to existing
                        bookings. There, the information at the time of booking
                        applies.
                      </p>
                    </div>
                    <p className="text-sm font-normal leading-8">
                      15.5 After the advertisement has been placed on the
                      website, the advertisement can be changed or deleted
                      retroactively as long as no sports contract has been
                      concluded in accordance with clause 16. The provisions of
                      the preceding sentence shall also apply to individual
                      agreements of the parties. Once a sports contract has been
                      concluded, the advertisement cannot be changed or deleted
                      retroactively for this sports contract, but can only be
                      adapted for future presentation on the moverii platform.
                      Requests for changes to the listing shall be communicated
                      by the provider to moverii by written or verbal
                      communication or via the functions enabled for this
                      purpose on the platform. moverii shall endeavor to enter
                      these in a timely manner.
                    </p>
                  </article>

                  <article
                    id="term16"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      16. booking process, conclusion of the sports contract,
                      moverii as messenger, no insurance
                    </p>
                    <p className="text-sm font-normal leading-8">
                      16.1 The legally binding agreement between a provider and
                      a customer about the paid execution of sports offers
                      according to the information in the advertisement takes
                      place exclusively through the conclusion of a sports
                      contract on the website according to the following
                      provisions and, if applicable, with the inclusion of
                      supplementary provisions of the provider according to
                      section 15.2 sentence 2.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      16.2 The legally binding conclusion of the sports contract
                      takes place in the case of an immediate booking as
                      follows:
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      a. The advertisement of the provider does not constitute a
                      legally binding offer, but merely an invitation to submit
                      a corresponding offer (invitatio ad offerendum).
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      b. The customer selects one of the sports offers, fills
                      out the booking form and provides necessary data for the
                      booking.
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      c. The customer confirms his selection by clicking the
                      button "Book now".
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      d. The customer has the possibility to check and correct
                      his data again. For this purpose moverii shall provide the
                      Customer with adequate, effective and accessible technical
                      means with the help of which the Customer can identify and
                      correct input errors before the binding booking. The
                      customer can, before sending the binding booking, by
                      pressing the "back" button in the booking form after
                      checking his information, return to the website where the
                      customer's information is recorded and correct input
                      errors or cancel the booking process by closing the
                      browser.
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      e. The customer submits a legally binding offer to the
                      provider to conclude a sports contract at the conditions
                      stated in the advertisement by pressing the button "Book
                      now with obligation to pay".
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      f. moverii automatically accepts the offer of the customer
                      in the name and for the account of the provider, whereby a
                      legally effective sports contract is concluded.
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      g. After the conclusion of the sports contract, the
                      provider and the customer, for the purpose of proof and
                      not as a condition of effectiveness, an electronic summary
                      about the sports contract concluded on the website will be
                      sent in text form to the e-mail addresses stored in the
                      respective account.
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      16.3 The legally binding conclusion of the sports contract
                      takes place in the case of an acceptance booking as
                      follows:
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      a. The Provider shall include all necessary content in an
                      Advertisement in accordance with Section 12.1. The
                      advertisement of the Provider does not constitute a
                      legally effective offer, but merely an invitation to
                      submit a corresponding offer (invitatio ad offerendum).
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-normal leading-8">
                        When an offer is booked, a contract is concluded between
                        the provider of the sports trip and the customer. The
                        content of the contract is the information from the
                        offer as well as possible additional general terms and
                        conditions of the provider. These are shown in the
                        section about providers. Providers are solely
                        responsible for the execution of the contract.
                      </p>
                      <p className="text-sm font-normal leading-8">
                        For the booking there are two options that providers can
                        offer. With a direct booking, customers can book the
                        offer directly with the payment legally binding. A
                        confirmation of availability on the part of the provider
                        is not necessary.
                      </p>
                      <p className="text-sm font-normal leading-8">
                        The entire payment process runs through our platform.
                        Unless otherwise stated in the offer, there are no
                        additional costs for customers.
                      </p>
                    </div>
                    <p className="text-sm font-normal pl-4  leading-8">
                      b. The customer submits a legally binding offer to the
                      provider to conclude a sports contract at the conditions
                      stated in the advertisement by clicking the button "Book
                      now with obligation to pay" in the advertisement.
                    </p>

                    <p className="text-sm font-normal pl-4  leading-8">
                      c. The provider can decide after receipt of the offer,
                      within a period specified by moverii, whether he accepts
                      the offer to conclude a sports contract by which a legally
                      effective sports contract is concluded.
                    </p>

                    <p className="text-sm font-normal pl-4  leading-8">
                      d. The provider processes the offers of the customers in
                      the order of their receipt. The provider will refuse the
                      booking of additional customers once the maximum number of
                      participants for a sports offer has been reached.
                    </p>

                    <p className="text-sm font-normal pl-4  leading-8">
                      e. After the conclusion of the sports contract, the
                      provider and the customer, for the purpose of proof and
                      not as a condition of effectiveness, an electronic summary
                      of the sports contract concluded on the platform will be
                      sent in text form to the e-mail addresses stored in the
                      respective account.
                    </p>

                    <p className="text-sm font-normal pl-4  leading-8">
                      f. If the Provider does not submit an offer within the
                      time period specified by moverii after receipt of the
                      offer, the offer shall be deemed rejected. In this case a
                      sports contract is not concluded.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      16.4 The provider agrees not to claim any additional
                      costs, fees, commissions or similar claims against the
                      customer beyond the total price stated in the
                      advertisement.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      16.5. moverii receives and transmits the relevant
                      declarations for the conclusion of the contract on behalf
                      of the provider and the customer. moverii acts as a
                      messenger. moverii does not make its own declarations for
                      the conclusion of the sports contract.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      16.6. moverii does not provide insurance for the users. As
                      far as claims for damages against the provider arise in
                      connection with the sports offers, the provider is obliged
                      to take care of a proper settlement and if necessary a
                      sufficient insurance coverage.
                    </p>
                  </article>

                  <article
                    id="term17"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      17. booking price and moverii fee, circumvention
                    </p>
                    <p className="text-sm font-normal leading-8">
                      17.1 The registration on the website, as well as the
                      posting of advertisements on the website, as well as the
                      viewing of the posted advertisements are free of charge
                      for all users.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      17.2 With the conclusion of a sports contract, a claim of
                      the Provider against the Customer for the remuneration for
                      the sports offer (hereinafter "booking price") arises. The
                      amount of the booking price is determined exclusively by
                      the provider, subject to clause 17.3. For the services of
                      moverii in connection with the mediation of a sports
                      contract between the Provider and the Customer, moverii
                      shall charge the Provider a fee (hereinafter "moverii
                      Fee"). moverii's claim to the moverii fee arises for each
                      successfully concluded contract according to clause 16.2
                      and clause 16.3 on the website.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      17.3 Providers undertake under a minimum price guarantee
                      for Advertisements listed and published on the moverii
                      Platform not to offer lower prices elsewhere and expressly
                      declare that the prices communicated to moverii, made
                      available or uploaded directly via the Platform are the
                      lowest prices offered by the Provider for the services
                      described in the Advertisement. In case of a violation of
                      this minimum price guarantee, moverii reserves the right
                      to claim appropriate damages from the provider and to
                      exclude the provider from using the moverii platform.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      17.4 The amount of the moverii fee shall be determined in
                      accordance with the Provider's agreements with moverii and
                      shall comprise a fixed percentage of the booking price.
                      The moverii fee applies to all services included in the
                      booking price, including extra services such as connecting
                      nights, meals, transfer and transport services and
                      massages. Exceptions to this rule must be made explicitly
                      and separately.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      17.5 If, after the conclusion of a sports contract, the
                      sports offer is not carried out due to factual or legal
                      reasons, the moverii fee is not waived. moverii has
                      fulfilled its obligation to the users by proving the
                      opportunity to conclude a sports contract, by notifying
                      the provider and customer that the sports contract has
                      been concluded.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      17.6 Users are prohibited from circumventing the moverii
                      fee and the payment modalities regulated in section 18. If
                      users conclude a sports contract outside the website in
                      relation to a sports offer posted on the website, which
                      was initiated via the website (hereinafter referred to as
                      "circumvention"), moverii shall nevertheless be entitled
                      to payment of the moverii fee.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      In the event of a bypass, this is owed jointly and
                      severally by the provider and the customer for payment to
                      moverii.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-normal leading-8">
                        We work out of passion and conviction. Our mission is to
                        give suppliers good access to the market and to help
                        customers find their perfect dream trip. Of course, we
                        still have to finance ourselves - that's how the world
                        works.
                      </p>
                      <p className="text-sm font-normal leading-8">
                        However, it is important to us that customers are not
                        left with any extra costs: After all, the worst thing is
                        to find your dream trip and then realize when you start
                        your journey that the same journey is available at a
                        lower price. That's why we offer a binding best price
                        guarantee. Suppliers commit themselves not to offer
                        their sports trips cheaper elsewhere.
                      </p>
                      <p className="text-sm font-normal leading-8">
                        We work on a success basis. Suppliers do not pay any
                        fixed costs or other fees to market their offers via our
                        platform. Instead, suppliers pay a commission after a
                        booking is completed. We see this commission as a
                        marketing share calculated into the budget of the
                        journeys.
                      </p>
                      <p className="text-sm font-normal leading-8">
                        Also essential for us is trust. We are happy when
                        customers find direct access to providers and do not
                        want to control our users. If a booking is made as a
                        result, we simply want to trust that suppliers will let
                        us know and pay the commission. This trust is worth more
                        to us than any controls or penalties and is a basic
                        condition for any successful cooperation.
                      </p>
                    </div>

                    <p className="text-sm font-normal leading-8">
                      17.7 Suppliers are obliged to disclose any sports
                      contracts concluded outside the website for a sports offer
                      posted on the website, which was initiated via the
                      website, be it via a form, an email or a phone call,
                      within 7 days. If moverii on its own initiative inquires
                      with the provider about the possible conclusion of a
                      sports contract and does not receive an answer to this
                      inquiry within 4 weeks, then the sports contract is
                      considered to have been concluded and also as
                      circumvention with a corresponding payment debt in the
                      amount of the moverii fee. moverii reserves the right to
                      inquire with both the end customer and the provider
                      whether corresponding sports contracts have been concluded
                      and circumvention has taken place. Should moverii in this
                      course or otherwise come to know that a contact made
                      through the platform resulted in a concluded sports
                      contract and the provider has failed to disclose this, the
                      provider is obliged to a compensation payment in the
                      amount of ten times (10x) the actual moverii fee, but at
                      least a payment in the amount of 500.00 euros.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      17.8 The booking price and the moverii fee are - unless
                      expressly stipulated otherwise - due for payment
                      immediately after the conclusion of the sports contract
                      and are to be paid in accordance with the specified
                      payment modalities pursuant to clause 18.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Wir arbeiten aus Leidenschaft und Überzeugung. Unsere
                      Mission ist es Anbietern einen guten Zugang zum Markt zu
                      ermöglichen und Kunden zu ihrer perfekten Wunschreise zu
                      verhelfen. Finanzieren müssen wir uns natürlich trotzdem -
                      so funktioniert die Welt.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Es ist uns jedoch wichtig, dass Kunden auf keinen extra
                      Kosten sitzen bleiben: Immerhin ist es das Schlimmste,
                      wenn die Traumreise gefunden ist und dann bei Reiseantritt
                      zu merken, dass es dieselbe Reise auch günstiger gibt.
                      Deshalb bieten wir eine verbindliche Bestpreisgarantie.
                      Anbieter verpflichten sich, ihre Sportreisen anderswo
                      nicht günstiger anzubieten.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Wir arbeiten auf Erfolgsbasis. Anbieter zahlen keine
                      Fixkosten oder sonstige Gebühren, um ihre Angebote über
                      unsere Plattform zu vermarkten. Stattdessen zahlen
                      Anbieter nach abgeschlossener Buchung eine Provision.
                      Diese Provision sehen wir wie ein Marketing Anteil, der in
                      das Budget der Reisen einkalkuliert wurde.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Außerdem unerlässlich für uns ist Vertrauen. Wir freuen
                      uns, wenn Kunden den direkten Zugang zu Anbietern finden
                      und möchten unsere Nutzer nicht kontrollieren. Wenn
                      daraufhin eine Buchung zustande kommt, möchten wir uns
                      einfach darauf verlassen, dass Anbieter uns Bescheid geben
                      und die Provision entrichten. Dieses Vertrauen ist für uns
                      vielmehr wert als irgendwelche Kontrollen oder Strafen und
                      eine Grundbedingungen für jede erfolgreiche
                      Zusammenarbeit.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      17.7. Anbieter sind verpflichtet, außerhalb der Website
                      abgeschlossene Sportverträge für eines auf der Website
                      eingestelltes Sportangebot, welches über die Website, sei
                      es über ein Formular, eine E-Mail oder einen Telefonanruf,
                      angebahnt wurde, innerhalb von 7 Tagen offenzulegen. Wenn
                      moverii von sich aus bei dem Anbieter über den möglichen
                      Abschluss eines Sportvertrages nachfragt und auf diese
                      Rückfrage innerhalb von 4 Wochen keine Antwort erhält,
                      dann gilt der Sportvertrag als zustande gekommen und
                      ebenfalls als Umgehung mit einer entsprechenden
                      Zahlungsschuld in Höhe der moverii-Gebühr. moverii behält
                      sich das Recht vor, sowohl beim Endkunden als auch beim
                      Anbieter nachzufragen, ob entsprechende Sportverträge
                      abgeschlossen wurden und eine Umgehung stattgefunden hat.
                      Sollte moverii in diesem Zuge oder anderweitig in
                      Erfahrung bringen, dass ein über die Plattform zustande
                      gekommener Kontakt in einem abgeschlossenen Sportvertrag
                      mündete und der Anbieter es unterlassen hat dies offen zu
                      legen, so ist der Anbieter zu einer Ersatzzahlung in Höhe
                      des Zehnfachen (10x) der eigentlich anfallenden
                      moverii-Gebühr, mindestens aber zu einer Zahlung in Höhe
                      von 500,00 Euro verpflichtet.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      17.8. Der Buchungspreis und die moverii-Gebühr sind -
                      soweit nicht ausdrücklich anderweitig bestimmt - sofort
                      nach Abschluss des Sportvertrages zur Zahlung fällig und
                      nach Maßgabe der vorgegebenen Zahlungsmodalitäten gemäß
                      Ziffer 18 zu begleichen.
                    </p>
                  </article>

                  <article
                    id="term18"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      18. Zahlungsmodalitäten
                    </p>
                    <p className="text-sm font-normal leading-8">
                      18.1. Die Zahlung von Buchungspreis und moverii-Gebühr
                      erfolgt ausschließlich nach Maßgabe der Regelungen dieser
                      Ziffer 18. moverii behält sich vor, einzelne Zahlungsarten
                      gegenüber ausgewählten Nutzern auszuschließen, soweit
                      aufgrund begründeter Anhaltspunkte eine Rücklastschrift
                      bzw. Stornierung der Zahlung oder eine unzureichende
                      Deckung des zu belastenden Bankkontos zu befürchten ist.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      18.2. Die moverii-Gebühr und der Buchungspreis sind mit
                      schuldbefreiender Wirkung ausschließlich unter Verwendung
                      der von moverii auf der Website angegeben Zahlungsarten zu
                      leisten. moverii leitet den Buchungspreis nach Abzug der
                      moverii-Gebühr, vorbehaltlich der Regelung nach Ziffer
                      18.3 und Ziffer 18.4, in der Regel am ersten Freitag nach
                      erfolgreichem Eingang des Buchungspreises, spätestens
                      allerdings nach Ablauf eines Monats oder nach Fristen, die
                      der Anbieter gemäß Ziffer 12.2 festgelegt hat, an den
                      Anbieter weiter. Die Auszahlung erfolgen in der lokalen
                      Währung des Anbieters und die Endbeträge werden
                      entsprechend des aktuellen Wechselkurses am Tag der
                      Auszahlung berechnet.
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      a. entweder der Kunde oder der Anbieter einen Konfliktfall
                      gemeldet hat (z.B. bei Streitigkeiten im Zusammenhang mit
                      zu entrichtenden Entgelten sowie Mängeln oder Schäden);
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      b. die vom Kunden geleistete Zahlung durch diesen oder
                      durch Dritte vor der Auszahlung des Buchungspreises an den
                      Anbieter wieder zurückgefordert wird;
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Auf unserer Plattform stehen Kunden verschiedene
                        Zahlungsmodalitäten zur Verfügung. Nach erfolgreichem
                        Eingang einer Zahlung und somit Bestätigung der Buchung
                        zahlen wir den Preis abzüglich der Provision an den
                        Anbieter weiter, in der Regel direkt am nächsten
                        Freitag. Bei Verdacht auf Betrug oder ähnliches können
                        wir die Auszahlung bis zur Klärung verzögern - Vorkommen
                        wird das hoffentlich nicht.
                      </p>
                    </div>

                    <p className="text-sm font-normal  leading-8">
                      18.3. moverii ist berechtigt, die Auszahlung des
                      Buchungspreises an den Anbieter zum Schutz der Interessen
                      des Kunden und des Anbieters bis zu 12 Monate lang zu
                      verweigern, soweitg as
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      c. und solange moverii begründete Anhaltspunkte dafür
                      vorliegen, dass der Sportvertrag zwischen Anbieter und
                      Kunde nur zum Schein oder rechtsmissbräuchlich vereinbart
                      wurde (z.B. bei Anhaltspunkten für einen
                      Versicherungsbetrug).
                    </p>
                    <p className="text-sm font-normal leading-8">
                      18.4. moverii wird in den unter Ziffer 18.3 a bis b
                      genannten Fällen die Auszahlung veranlassen, soweit sowohl
                      der Kunde als auch der Anbieter gegenüber moverii in
                      Textform einer Auszahlung an einen moverii zu benennenden
                      Empfänger zugestimmt haben. Im Übrigen wird moverii eine
                      Auszahlung veranlassen, wenn moverii eine beglaubigte
                      Kopie der vollstreckbaren Ausfertigung einer gerichtlichen
                      Entscheidung oder eines sonstigen Vollstreckungstitels
                      vorgelegt wird. Ungeachtet des Vorstehenden wird moverii
                      eine Auszahlung spätestens nach Ablauf von 12 Monaten ab
                      Vertragsschluss des Sportvertrages veranlassen.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      18.5. Unsere Zahlungen werden von dem
                      Zahlungsdienstleister Mangopay abgewickelt. Die
                      Allgemeinen Geschäftsbedingungen von Mangopay gelten und
                      sind hier abrufbar:{" "}
                      <a
                        href="https://mangopay.com/terms-and-conditions/payment-services"
                        target="_blank"
                        className="!text-blue-600 underline"
                      >
                        Mangopay’s allgemeine Geschätsbedingungen
                      </a>
                      .
                    </p>
                  </article>

                  <article
                    id="term19"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      19. Bestpreisgarantie
                    </p>
                    <p className="text-sm font-normal leading-8">
                      19.1. Wenn Kunden zum Zeitpunkt ihrer Buchung oder bis zum
                      Zeitpunkt der Erfüllung des zustande gekommenen
                      Sportvertrag auf einer anderen Website einen günstigeren
                      Preis für dieselben Leistungen vorbehaltlich der
                      Bestimmungen aus Ziffern 18.2. und 18.3. finden, ist der
                      Kunde dazu berechtigt, moverii mit der Bitte um eine
                      Erstattung des Differenzpreis zu kontaktieren. Die
                      Kontaktaufnahme kann über alle ausgeschriebenen
                      Kommunikationskanäle stattfinden und soll eine
                      Dokumentation des niedriger ausgeschriebenen Preis und der
                      Quelle enthalten. Dieses Angebot muss zum Zeitpunkt der
                      Kontaktaufnahme zur Buchung verfügbar sein. Dies wird von
                      dem Support-Team von moverii festgelegt. Ein Anspruch auf
                      Erstattung des Differenzpreis besteht nur, wenn der
                      Sportvertrag im Sinne von Ziffer 15.2. und 15.3. über die
                      moverii Plattform zustande gekommen ist.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      21.2. moverii ist nicht verpflichtet Streitigkeiten oder
                      Schadensersatzansprüche der Nutzer untereinander zu
                      regeln, oder an deren Beilegung oder Lösung mitzuwirken.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      21.3. Der Nutzer wird ausdrücklich darauf hingewiesen,
                      dass beim Abschluss von Sportverträgen mit Verbrauchern
                      Widerrufsrechte und sonstige Verbraucherschutzrechte in
                      Betracht kommen, hinsichtlich derer er gegebenenfalls
                      seinen Vertragspartner zu belehren hat.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      21.4. Soweit die entgeltliche Durchführung der
                      Sportangebote zu Einkünften des Anbieters führt, die der
                      Besteuerung unterliegen, ist dieser verpflichtet, für eine
                      ordnungsgemäße Versteuerung der Einkünfte Sorge zu tragen.
                    </p>
                  </article>

                  <article
                    id="termC"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-4xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      C. Widerrufsbelehrung
                    </p>
                  </article>

                  <article
                    id="term20"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      Widerrufsrecht
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Du hast das Recht, binnen vierzehn Tagen ohne Angabe von
                      Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist
                      beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      Um dein Widerrufsrecht auszuüben, musst du uns (moverii -
                      Adrian Helbig Daniel Helbig GbR, Schloßstraße 4, 53115
                      Bonn, Deutschland, Tel.: 0151 7037 6939, E-Mail:
                      team@moverii.de) mittels einer eindeutigen Erklärung (z.B.
                      ein mit der Post versandter Brief, oder E-Mail) über
                      deinen Entschluss, diesen Vertrag zu widerrufen,
                      informieren. Du kannst dafür das beigefügte
                      Muster-Widerrufsformular verwenden, das jedoch nicht
                      vorgeschrieben ist.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Zur Wahrung der Widerrufsfrist reicht es aus, dass du die
                      Mitteilung über die Ausübung des Widerrufsrechts vor
                      Ablauf der Widerrufsfrist absendest.
                    </p>
                  </article>

                  <article
                    id="term20"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      Folgen des Widerrufs
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Wenn du diesen Vertrag widerrufst, haben wir dir alle
                      Zahlungen, die wir von dir erhalten haben, unverzüglich
                      und spätestens binnen vierzehn Tagen ab dem Tag
                      zurückzuzahlen, an dem die Mitteilung über deinen Widerruf
                      dieses Vertrags bei uns eingegangen ist. Für diese
                      Rückzahlung verwenden wir dasselbe Zahlungsmittel, das du
                      bei der ursprünglichen Transaktion eingesetzt haben, es
                      sei denn, mit dir wurde ausdrücklich etwas anderes
                      vereinbart; in keinem Fall werden dir wegen dieser
                      Rückzahlung Entgelte berechnet.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      Hast du verlangt, dass die Dienstleistungen während der
                      Widerrufsfrist beginnen soll, zum Beispiel, in dem du
                      Einheiten deiner gebuchten Karte bereits verwendet hast,
                      hast du uns einen angemessenen Betrag zu zahlen, der dem
                      Anteil der bis erbrachten Dienstleistungen im Vergleich
                      zum Gesamtumfang der im Vertrag vorgesehenen
                      Dienstleistungen entspricht.
                    </p>
                  </article>

                  <article
                    id="term20"
                    className="mt-6 flex mb-16 w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      Muster-Widerrufsformular
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Wenn du den Vertrag widerrufen willst, dann kannst du
                      diese Vorlage verwenden und sie uns als Formular
                      zuschicken.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      - An
                      <br />
                      moverii - Adrian Helbig Daniel Helbig GbR Castle Street 4
                      <br />
                      53115 Bonn
                      <br />
                      E-mail: team@moverii.de
                      <br />
                      - Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*)
                      abgeschlossenen Vertrag über die Erbringung der folgenden
                      Dienstleistung (*)
                      <br />
                      - Bestellt am (*)
                      <br />
                      - Anschrift des/der Verbraucher(s)
                      <br />
                      - Unterschrift des/der Verbraucher(s) (nur bei Mitteilung
                      auf Papier)
                      <br />
                      - Datum
                      <br />
                      ___________
                      <br />
                      (*) Unzutreffendes streichen.
                      <br />
                      Status: April 2020
                      <br />
                    </p>
                  </article>
                </section>
              </div>
            </main>
          ) : (
            <main className="w-full">
              <h1 className=" mt-14 w-full  px-0 text-4xl font-bold mb-14 ">
                AGBs/ Widerrufsbelehrung
              </h1>
              <div className=" grid w-full  grid-cols-1 leading-10 items-start justify-items-center gap-y-4 px-4 md:px-0 lg:grid-cols-[1fr_2fr]">
                <aside className="flex sticky w-full flex-col items-start justify-center border-[#C4C4C4] pr-4 lg:border-r">
                  <p className="text-3xl font-bold mb-10 text-[#FF9F1C]">
                    Inhaltsverzeichnis
                  </p>
                  <ul className="text-sm space-y-2 font-medium leading-7 ">
                    <li>
                      <a className={"capitalize text-base"} href="">
                        A. Allgemeine Geschäftsbedingungen{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term1"
                        className={"capitalize pl-0 block mb-4 text-gray-700"}
                      >
                        1. Geltungsbereich Ausschluss abweichender
                        Geschäftsbedingungen
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term2"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        2.Vertragsgegenstand
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term3"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        3. Vertragsschluss mit dem Anbieter
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term4"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        4. Mitwirkungspflichten des Anbieters{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term5"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        5. Einräumung von Nutzungsrechten
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term6"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        6. Verfügbarkeit der Website{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term7"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        7. Laufzeit und Kündigung des Nutzungsvertrags
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term8"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        8. Haftungsbeschränkungen von moverii{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term9"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        9. Freistellung{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term10"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        10. Links zu Websites dritter Parteien, optionale Tools
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term11"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        11. Bewertungen, Feedback
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term12"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        12. Internationales Reisen
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term13"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        13. Ausschluss fremder AGB, Anwendbares Recht,
                        Gerichtsstand, Erfüllungsort
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term14"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        14. Änderung dieser AGB
                      </a>
                    </li>
                    <li>
                      <a href="#termB" className={"capitalize text-base"}>
                        B. Besondere Bedingungen für die Nutzung der Website
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term15"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        15. Einstellung eines Sportangebotes{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term16"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        16. Buchungsprozess & Vertragsschluss{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term17"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        17. Buchungspreis und moverii-Gebühr{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term18"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        18. Zahlungsmodalitäten{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term19"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        19. Bestpreisgarantie{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term20"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        20. Stornierungsbedingungen{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#term21"
                        className={
                          "capitalize pl-0 block mb-4 text-gray-700 text-sm"
                        }
                      >
                        21. Sonstige Hinweise{" "}
                      </a>
                    </li>

                    <li>
                      <a href="#termC" className={"capitalize  text-base"}>
                        C. Widerrufsbelehrung
                      </a>
                    </li>
                  </ul>
                </aside>
                <section className="flex w-full leading-10 flex-col items-start  justify-start lg:pl-10">
                  <article
                    id="term1"
                    className="flex w-full flex-col items-start justify-start"
                  >
                    <p
                      className={"text-xl font-bold capitalize mb-3 leading-10"}
                    >
                      1. Geltungsbereich Ausschluss abweichender
                      Geschäftsbedingungen
                    </p>
                    <p className="text-sm leading-8 font-normal leading-6">
                      1.1. Die nachfolgenden allgemeinen Geschäftsbedingungen
                      (nachfolgend „<b>AGB</b>“) gelten für das von der Adrian
                      Helbig, Daniel Helbig GbR, Schloßstraße 4, 53115 Bonn,
                      Deutschland (nachfolgend „<b>moverii</b>“) betriebene
                      Dienstleistungsangebot, das unter der Domain moverii.de
                      (nachfolgend „<b>Website</b>“) vorgehalten wird.
                    </p>
                    <p className="text-sm leading-8 font-normal leading-6">
                      1.2. Es gilt darüber hinaus die Datenschutzerklärung
                      (abrufbar unter <a href={"/"}>diesem Link</a>).
                    </p>
                    <p className="text-sm leading-8 font-normal leading-6">
                      1.3. Maßgebend ist die jeweils bei Abschluss des Vertrags
                      gültige Fassung der AGB.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In other words:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Im folgenden findest du die AGBs für unsere Website. In
                        diesen Boxen geben wir euch jeweils eine kleine und
                        verständliche Zusammenfassung. Die Zusammenfassung dient
                        zur allgemeinen Orientierung und ist rechtlich nicht
                        bindend.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term2"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold capitalize mb-3 leading-10">
                      2. Vertragsgegenstand{" "}
                    </p>
                    <p className="text-sm leading-8 font-normal leading-6">
                      2.1. moverii betreibt die Website auf der Nutzer
                      (nachfolgend „<b>Nutzer</b>“), das auf der Website
                      verfügbare Angebot, im zur Verfügung gestellten Rahmen und
                      nach Maßgabe dieser AGB, nutzen können. Die Nutzung der
                      Website kann Kosten und Gebühren auslösen (vgl. Ziffer
                      17).
                    </p>
                    <p className="text-sm leading-8 font-normal leading-6">
                      2.2. Die Website bietet Unternehmern, juristischen
                      Personen, Personengesellschaften und natürlichen Personen
                      die Möglichkeit im Rahmen der Regelungen dieser AGB
                      Dienst- und Reiseleistungen aus den Bereichen Sport,
                      Fitness und Freizeit (nachfolgend „<b>Sportangebot</b>“)
                      anzubieten (nachfolgend „<b>Anbieter</b>“). Die Website
                      bietet zudem natürlichen Personen, die nicht zum Zwecke
                      ihrer gewerblichen oder ihrer selbständigen beruflichen
                      Tätigkeit handeln, sog. Verbrauchern, die Möglichkeit im
                      Rahmen der Regelungen dieser AGB die von den Anbietern
                      eingestellten Sportangebote zu buchen (nachfolgend „
                      <b>Kunde</b>“).
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Anbieter von Sport- und Aktivreisen können ihre Angebote
                        über unsere Plattform anbieten. Wir selber organisieren
                        keine Reisen. Wenn du als Kunde eine Sportreise über
                        unsere Plattform buchst, kommt ein unabhängiger Vertrag
                        mit dem Reiseanbieter zustande.
                      </p>
                    </div>
                    <p className="text-sm leading-8 font-normal leading-6">
                      2.3. Die rechtsverbindliche Buchung von Sportangeboten
                      zwischen einem Anbieter und einem Kunden (nachfolgend „
                      <b>Sportvertrag</b>“) wird in Ziffer B dieser AGB näher
                      erläutert und ist kostenpflichtig (vgl. Regelung in Ziffer
                      17).
                    </p>

                    <p className="text-sm font-normal leading-8">
                      2.4. moverii selbst bietet keine Sportangebote zur Buchung
                      an, sondern stellt den Nutzern die Website zur Nutzung zur
                      Verfügung und fungiert als Vermittler zwischen Anbieter
                      und Kunde. moverii wird nicht Vertragspartei des
                      Sportvertrages. Nutzer haben daher keinen Anspruch
                      gegenüber moverii auf Abschluss eines Sportvertrages.
                      moverii ist weder an der inhaltlichen Ausgestaltung der
                      Sportangebote, noch an der Durchführung der Sportverträge
                      selbst beteiligt. moverii hat keinerlei Einfluss auf die
                      Inhalte der Sportangebote oder auf den Zustand, die
                      Rechtmäßigkeit, Geeignetheit oder Qualität der
                      Sportangebote. Ferner werden die auf der Website von
                      Nutzern veröffentlichten Inhalte von moverii grundsätzlich
                      nicht geprüft und stellen keine Angaben oder Meinungen von
                      moverii dar.
                    </p>
                  </article>

                  <article
                    id="term3"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      3. Vertragsschluss mit dem Anbieter
                    </p>
                    <p className="text-sm leading-8 font-normal leading-6">
                      moverii überlässt dem Anbieter in schriftlicher oder
                      mündlicher Kommunikation ein verbindliches Angebot auf
                      Abschluss eines Nutzungsvertrages zur Nutzung der Website
                      inklusive der Höhe und dem Umfang der
                      Provisionsvereinbarung (nachfolgend „
                      <b>Nutzungsvertrag</b>“). Durch Bestätigung des Angebots
                      (nachfolgend „<b>Bestätigung</b>“) nimmt der Anbieter das
                      Angebot von moverii an und es kommt ein Nutzungsvertrag
                      nach den hier bestimmten sowie zusätzlichen schriftlich,
                      typischerweise in Email Kommunikation festgehalten
                      Konditionen zustande. Als Bestätigung gelten auch die
                      Anbahnung, Fortführung oder Fertigstellung eines Inserates
                      des Anbieters auf der Plattform, unabhängig davon, ob
                      dieses Inserat durch den Anbieter oder durch moverii
                      angelegt wurde. Wird die Bestätigung nicht innerhalb von 4
                      Wochen ab Zugang des Angebotes durch den Anbieter
                      angenommen, kommt kein Vertrag zwischen moverii und dem
                      Anbieter zustande.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Anbieter von Sport- und Aktivreisen können ihre Angebote
                        über unsere Plattform anbieten. Wir selber organisieren
                        keine Reisen. Wenn du als Kunde eine Sportreise über
                        unsere Plattform buchst, kommt ein unabhängiger Vertrag
                        mit dem Reiseanbieter zustande.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term4"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      4. Mitwirkungspflichten des Anbieters
                    </p>
                    <p className="text-sm font-normal leading-8">
                      4.1. Der Erfolg oder Misserfolg der Zusammenarbeit von
                      moverii und dem Anbieter hängt auch entscheidend davon ab,
                      ob und in welchem Umfang der Anbieter im Rahmen seiner
                      Leistungsfähigkeit an der Realisierung des
                      Nutzungsvertrages mitwirkt. Dieser ist daher insbesondere
                      verpflichtet:
                    </p>
                    <p className="text-sm pl-4 font-normal leading-8">
                      a. moverii und dessen zur Durchführung des
                      Nutzungsvertrages eingesetztem Personal und
                      Subunternehmern alle notwendigen Informationen und
                      Auskünfte zu erteilen. Im Übrigen verschafft der Anbieter
                      moverii von ihm zu stellende Unterlagen, Dateien, Vorlagen
                      und sonstige für die Durchführung der Einstellung der
                      Sportangebote notwendigen Informationen unaufgefordert,
                      möglichst früh- bzw. rechtzeitig zur Vertragserfüllung und
                      frei von Rechten Dritter.
                    </p>
                    <p className="text-sm pl-4 font-normal leading-8">
                      b. Der Anbieter benennt gegenüber moverii einen
                      kompetenten Ansprechpartner, der berechtigt ist
                      rechtswirksame Erklärungen im Namen des Anbieters
                      abzugeben.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Wir halten die Reisen und Angebote auf unserer Plattform
                        immer aktuell. Damit wir das auch können, verpflichten
                        unsere Partner sich dazu uns entsprechend mit
                        Informationen zu unterstützen.
                      </p>
                    </div>

                    <p className="text-sm font-normal leading-8">
                      4.2. Solange der Anbieter dies nicht oder nicht
                      ordnungsgemäß erfüllt, und dies dazu führt, dass moverii
                      seinen Pflichten nicht nachkommen kann, tritt auf Seiten
                      von moverii kein Verzug ein.
                    </p>
                  </article>

                  <article
                    id="term5"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      5. Einräumung von Nutzungsrechten
                    </p>
                    <p className="text-sm font-normal leading-8">
                      5.1. moverii räumt dem Nutzer ausschließlich zum Zwecke
                      der Nutzung der Website im Umfang und nach Maßgabe der AGB
                      für die Dauer des Nutzungsvertrags das örtlich
                      unbeschränkte, widerrufliche, nicht-ausschließliche,
                      nicht-unterlizenzierbare und nicht übertragbare Recht ein,
                      die Website zu nutzen. Das Eigentums- und Urheberrecht an
                      der Website verbleibt ausschließlich bei moverii.
                    </p>
                    <p className="text-sm leading-8 font-normal leading-6">
                      5.2. Der Anbieter räumt moverii das einfache, räumlich und
                      zeitlich unbeschränkte, weltweite, übertragbare und
                      unterlizenzierbare Nutzungsrecht an sämtlichen von ihm für
                      die Website zur Verfügung gestellten Inhalte (z.B. Logos,
                      Bilder, Videos, Texte) (nachfolgend „<b>Inhalte</b>“) ein
                      (nachfolgend „<b>Lizenz</b>“). Als zur Verfügung gestellt
                      gilt dabei alles, was elektronisch oder postalisch an
                      moverii übersendet oder mit Zustimmung des Anbieters von
                      moverii auf öffentlich zugänglichen Domänen oder durch den
                      Anbieter verwiesenen Internetseiten, inklusive der Social
                      Media Seiten des Anbieters, heruntergeladen wurde. Hiervon
                      erfasst ist insbesondere das Recht der Vervielfältigung,
                      der Verwendung, des Betreibens, des Kopierens, des
                      öffentlichen Vorführens oder Anzeigens, des Verbreitens,
                      des Modifizierens, des Übersetzens und des Erstellen von
                      abgeleiteten Versionen sowie das Recht der Bearbeitung.
                      moverii ist insbesondere berechtigt, die Inhalte technisch
                      so zu bearbeiten, aufzubereiten und anzupassen, dass diese
                      auch auf mobilen Empfangsgeräten oder in
                      Softwareapplikationen von Dritten dargestellt werden
                      können.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      5.3. Die Lizenz endet, wenn der Anbieter moverii
                      auffordert seine Inhalte oder Sportangebote zu löschen; es
                      sei denn, die Inhalte wurden mit anderen Nutzern geteilt
                      und diese haben die Inhalte nicht gelöscht. Als Teil
                      dieser Beendigung bemüht sich moverii, ist jedoch nicht
                      verpflichtet, bereits veröffentlichte Inhalte zu löschen
                      oder vor der Vervielfältigung zu schützen.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Wenn Anbieter sich bei uns registrieren, dürfen wir
                        Bilder und Videos der Reisen zur Vermarktung der Reisen
                        nutzen. Wenn ein Anbieter den Nutzungsvertrag beendet,
                        dürfen wir das nicht mehr. Wir versuchen dann alles
                        Material zu löschen, können das aber nicht garantieren.
                      </p>
                    </div>

                    <p className="text-sm font-normal leading-8">
                      5.4. Die Lizenz umfasst außerdem das Recht die
                      Informationen aus werblichen Gründen auf anderen
                      Plattformen, beispielsweise auf sozialen Netzwerken wie
                      Facebook oder Instagram, zu nutzen und zu veröffentlichen.
                      Diese Plattformen haben in der Regel eigenständige
                      Nutzungsbedingungen und erwarten ihrerseits bestimmte
                      Nutzungsrechte. Mit Übertragung der Lizenz erklärt sich
                      der Anbieter damit einverstanden, dass die textuellen und
                      visuellen Informationen in diesen Netzwerken unter den
                      jeweils geltenden Nutzungsbedingungen veröffentlicht
                      werden. Sollte der Anbieter seinen Account löschen
                      und/oder seinen Vertrag kündigen, verbleiben etwaige
                      bereits eingeräumte Nutzungsrechte bei moverii oder seinen
                      Partnerunternehmen oder den jeweiligen Drittanbietern.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      5.5. Der Anbieter garantiert, dass er Inhaber der
                      übertragenen Rechte ist und dass es ihm möglich ist, die
                      in Ziffer 5.2 genannten Rechte wirksam einzuräumen. Der
                      Anbieter garantiert außerdem, dass die von ihm erstellten
                      Inhalte keine Rechte Dritter verletzen, insbesondere
                      Marken-, Wettbewerbs-, Urheber-, Eigentums- oder
                      Persönlichkeitsrechte. Bei entsprechendem Verstoß behält
                      moverii sich das Recht vor, sämtliche angefallenen Schäden
                      bei dem Anbieter geltend zu machen.
                    </p>
                  </article>

                  <article
                    id="term6"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      6. Verfügbarkeit der Website
                    </p>
                    <p className="text-sm font-normal leading-8">
                      moverii bietet die Website unter Vorbehalt der
                      Verfügbarkeit an. moverii bemüht sich, die Website stets
                      zugänglich zu halten. Durch Wartungsarbeiten,
                      Weiterentwicklung oder Störungen können die
                      Nutzungsmöglichkeiten eingeschränkt oder zeitweise
                      unterbrochen werden. Dadurch kann es unter Umständen auch
                      zu Datenverlusten kommen.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Wir versuchen zu gewährleisten, dass unsere Seite immer
                        abrufbar ist. Es könnte aber auch mal etwas schief
                        gehen.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term7"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      7. Laufzeit und Kündigung des Nutzungsvertrags
                    </p>
                    <p className="text-sm font-normal leading-8">
                      7.1. Der Nutzungsvertrag mit dem Anbieter wird auf
                      unbestimmte Zeit geschlossen.
                    </p>

                    <p className="text-sm leading-8 font-normal leading-6">
                      7.2. moverii oder der Anbieter können den Nutzungsvertrag,{" "}
                      <strong>
                        vorbehaltlich des nachfolgenden Satzes, mit einer Frist
                        von 14 Tagen kündigen.
                      </strong>{" "}
                      Hat der Anbieter vor der Kündigung einen Sportvertrag
                      abgeschlossen, wird die Kündigung jedoch nicht wirksam,
                      bevor der Sportvertrag vollständig durchgeführt,
                      aufgehoben oder in sonstiger Weise beendet worden ist. Für
                      die Kündigungserklärung genügt eine E-Mail an [
                      <a href="mailto:team@moverii.de">team@moverii.de</a>] oder
                      eine schriftliche Mitteilung an moverii.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      7.3. Das Recht zur Kündigung aus wichtigem Grund bleibt
                      unberührt.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Der Nutzungsvertrag mit Anbietern kann von beiden Seiten
                        mit einer Frist von 14 Tagen gekündigt werden. Davon
                        unberührt sind bereits bestehende Buchungen. Diese
                        müssen normal durchgeführt werden.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term8"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      8. Haftungsbeschränkungen von moverii
                    </p>
                    <p className="text-sm font-normal leading-8">
                      8.1. Vorbehaltlich der weiteren Regelungen dieser Ziffer 8
                      haftet moverii nur, wenn und soweit moverii, seinen
                      gesetzlichen Vertretern, leitenden Angestellten,
                      Mitarbeitern oder sonstigen Erfüllungsgehilfen Vorsatz
                      oder grobe Fahrlässigkeit zur Last fällt. Die Interaktion
                      zwischen Nutzern, Anbietern und Kunden auf der Plattform
                      geschieht auf eigene Verantwortung. Nutzer sind damit
                      einverstanden, dass moverii nicht für eventuell aus dieser
                      Interaktion entstammenden Verpflichtungen oder Belastungen
                      haftet. Nichtsdestotrotz verpflichten sich alle Nutzer
                      innerhalb der Plattform im Rahmen von Anstand und guten
                      Sitten zu interagieren. Ebensowenig haftet moverii für das
                      Verhalten der Nutzer, Anbieter oder Kunden bei Ausführung
                      eines Sportvertrages.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      8.2. Im Falle des Schuldnerverzugs von moverii oder der
                      von moverii zu vertretenden Unmöglichkeit der
                      Leistungserbringung sowie im Falle der Verletzung
                      wesentlicher Vertragspflichten (sog. Kardinalpflichten)
                      haftet moverii jedoch für jedes eigene schuldhafte
                      Verhalten oder das seiner gesetzlichen Vertreter,
                      leitenden Angestellten, Mitarbeiter oder sonstigen
                      Erfüllungsgehilfen. Als wesentliche Vertragspflichten
                      werden dabei abstrakt solche Pflichten bezeichnet, deren
                      Erfüllung die ordnungsgemäße Durchführung des Vertrages
                      überhaupt erst ermöglicht und auf deren Einhaltung der
                      Nutzer regelmäßig vertrauen darf.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      8.3. Außer bei Vorsatz oder grober Fahrlässigkeit von
                      moverii, seiner gesetzlichen Vertreter, leitenden
                      Angestellten, Mitarbeiter oder sonstigen
                      Erfüllungsgehilfen, ist die Haftung von moverii der Höhe
                      nach auf die bei Vertragsschluss typischerweise
                      vorhersehbaren Schäden begrenzt.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Damit es fair bleibt, haften wir nur, wenn wir grob
                        fahrlässig waren. Wir versuchen sicherzustellen, dass
                        keine Schäden vor oder während einer Sportreise
                        entstehen, garantieren können wir das nicht. Bei
                        entstandenen Schäden bemühen wir uns zu vermitteln und
                        das Problem zu aller Zufriedenheit zu lösen. Für die
                        Schäden haftet jedoch der Anbieter oder der Nutzer.
                      </p>
                    </div>
                    <p className="text-sm font-normal leading-8">
                      8.4. Die in den vorstehenden Ziffern 8.1 und 8.2
                      geregelten Haftungsausschlüsse und Haftungsbeschränkungen
                      gelten nicht im Falle der Übernahme ausdrücklicher
                      Garantien, bei Ansprüchen wegen fehlender zugesicherter
                      Eigenschaften und für Schäden aus der Verletzung des
                      Lebens, des Körpers oder der Gesundheit sowie im Fall
                      zwingender gesetzlicher Regelungen. Die in Ziffer 8.2
                      geregelten Haftungsbeschränkungen gelten ferner im Falle
                      eines Schuldnerverzugs von moverii nicht für Ansprüche auf
                      Verzugszinsen, auf die Verzugspauschale gemäß § 288 Abs. 5
                      BGB sowie auf Ersatz des Verzugsschadens, der in den
                      Rechtsverfolgungskosten begründet ist.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      8.5. Ansprüche nach dem Produkthaftungsgesetz bleiben von
                      den Regelungen dieser Ziffer 8 unberührt.
                    </p>
                  </article>

                  <article
                    id="term9"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      9. Freistellung
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Der Nutzer stellt moverii von allen Ansprüchen Dritter,
                      insbesondere von Ansprüchen wegen Urheberrechts- und
                      Persönlichkeitsrechtsverletzungen, die gegen moverii in
                      Zusammenhang mit der Ausübung der vertragsgegenständlichen
                      Rechte erhoben werden sollten, auf erstes Anfordern hin
                      frei. Der Nutzer ist verpflichtet, auch unbegründete
                      Ansprüche Dritter im Hinblick auf die oben genannten
                      Rechte abzuwehren. Dem Nutzer bekannt werdende
                      Beeinträchtigungen der vertragsgegenständlichen Rechte hat
                      dieser moverii unverzüglich mitzuteilen. moverii ist
                      berechtigt, selbst geeignete Maßnahmen zur Abwehr von
                      Ansprüchen Dritter oder zur Verfolgung seiner Rechte
                      vorzunehmen. Eigene Maßnahmen des Nutzers hat dieser im
                      Vorwege mit moverii abzustimmen. Die Freistellung
                      beinhaltet auch den Ersatz der Kosten, die moverii durch
                      eine Rechtsverfolgung/-verteidigung entstehen bzw.
                      entstanden sind. Davon unberührt bleiben weitergehenden
                      Schadensersatzansprüche von moverii. Soweit moverii die
                      Rechtsverletzung selbst zu vertreten hat, sind Ansprüche
                      gegen den Nutzer ausgeschlossen.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Natürlich geben wir unser Bestes! Aber sicher versteht
                        ihr auch, dass wir nicht alle Inhalte all unserer
                        Partner überprüfen können. Wenn damit etwas nicht
                        stimmt, zum Beispiel Urheberrechte verletzt werden, dann
                        ist der Anbieter dafür verantwortlich.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term10"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      10. Links zu Websites dritter Parteien, optionale Tools
                    </p>
                    <p className="text-sm font-normal leading-8">
                      10.1. Auf der moverii Plattform können sich Links zu
                      Webseiten von Drittanbietern befinden, die nicht mit
                      moverii verbunden sind. moverii ist nicht verantwortlich
                      für die Prüfung oder Bewertung des Inhalts oder der
                      Richtigkeit der Inhalte auf diesen Websites und übernimmt
                      keine Garantie und Haftung für Materialien oder Websites
                      Dritter oder für andere Materialien, Produkte oder
                      Dienstleistungen Dritter.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      10.2. moverii haftet nicht für Schäden, die im
                      Zusammenhang mit dem Kauf oder der Nutzung von Waren,
                      Dienstleistungen, Ressourcen, Inhalten oder anderen
                      Transaktionen im Zusammenhang mit Websites von dritten
                      Parteien entstehen. Nutzer sind dazu angehalten, die
                      Nutzungsbedingungen, Richtlinien und
                      Datenschutzbedingungen des Drittanbieters vor jeder
                      Transaktion gründlich zu prüfen. Beschwerden, Ansprüche,
                      Bedenken oder Fragen zu Produkten von Drittanbietern sind
                      an diese und nicht an moverii zu richten.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Auf unserer Seite befinden sich, wie überall, Links zu
                        anderen Webseiten. Wir wählen diese sorgfältig aus und
                        nutzen nur qualitative Links. Allerdings können wir auch
                        nicht alle anderen Webseiten ständig kontrollieren und
                        sind für diese nicht verantwortlich. Bitte schaut euch
                        also die Nutzungsbedingungen von externen Seiten an,
                        bevor ihr diese nutzt.
                      </p>
                    </div>
                    <p className="text-sm font-normal leading-8">
                      10.3. Auf der moverii Plattform können Tools von
                      Drittanbietern eingebunden sein, welche zur Nutzung der
                      Plattform nicht notwendig, aber optional sind. moverii hat
                      keine Möglichkeit zur Überwachung oder Kontrolle dieser
                      Services und übernimmt keinerlei Haftung für oder im
                      Zusammenhang mit der Verwendung optionaler Tools von
                      Drittanbietern. Die Verwendung erfolgt auf eigenes Risiko
                      und nach eigenem Ermessen. Nutzer sind dazu angehalten die
                      Nutzungsbedingungen, Richtlinien und
                      Datenschutzbedingungen des Drittanbieters vor jeder
                      Verwendung gründlich zu prüfen.
                    </p>
                  </article>

                  <article
                    id="term11"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      11. Bewertungen, Feedback
                    </p>
                    <p className="text-sm leading-8 font-normal leading-6">
                      Nutzer haben die Möglichkeit über Formulare auf der
                      moverii Webseite oder auf externen Webseiten oder in
                      direkter schriftlicher oder mündlicher Kommunikation,
                      Bewertungen für moverii oder einzelne Inserate abzugeben
                      sowie Ideen, Vorschläge, Empfehlungen oder Dokumente zur
                      Verbesserung der Plattform (nachfolgend “<b>Feedback</b>")
                      an moverii mitzuteilen. Mit Übermittlung dieses Feedbacks
                      räumen Nutzer moverii ein unwiderrufliches und
                      fortwährendes Recht zur Nutzung, Veröffentlichung und
                      Vervielfältigung dieses Feedbacks ein. Ein Anspruch auf
                      eine Kompensation in irgendeiner Form für die Übermittlung
                      dieses Feedbacks besteht nicht.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Auf unserer Seite könnt ihr sowohl Bewertungen für
                        Sportreisen als auch Feedback über oder für uns abgeben.
                        Wenn ihr das tut, dürfen wir dieses uneingeschränkt
                        nutzen und müssen euch nicht dafür kompensieren.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term12"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      12. Internationales Reisen
                    </p>
                    <p className="text-sm font-normal leading-8">
                      12.1. Die Sportangebote, die auf moverii veröffentlichten
                      Inseraten dargeboten sind, finden teilweise in anderen
                      Ländern statt. Das bedeutet nicht, dass das Reisen in die
                      entsprechenden Länder und Regionen risikofrei, geschweige
                      denn seitens moverii empfohlen ist. moverii haftet nicht
                      für Verluste oder Schäden, die durch Reisen im Rahmen der
                      über die Plattform abgeschlossenen Sportverträge entstehen
                      oder entstehen können.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      12.2. Kunden sind alleinig dafür verantwortlich, dass sie
                      alle Anforderungen für die Einreise ins Ausland erfüllen
                      und die für die Reise erforderlichen Dokumente, wie
                      Reisepässe und Visa, gültig und für die Einreise
                      organisiert sind. moverii bemüht sich, Kunden vor
                      Erfüllung des Sportvertrages auf die derzeit geltenden
                      Reisehinweise und -Beschränkungen des Auswärtigen Amtes,
                      garantiert jedoch nicht dafür oder für die Richtigkeit der
                      darüber zugänglichen Informationen. Kunden sind selber
                      dazu angehalten, sämtliche Reiseverbote, Reisewarnungen,
                      Reisebestimmungen und Reisehinweise, sowohl von der
                      Regierung des Ursprungs- als auch von der Regierung des
                      Ziellandes vor Abschluss eines Sportvertrages gründlich zu
                      überprüfen.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Wir alle lieben Reisen und sind selber viel unterwegs.
                        Wenn wir also mitbekommen, dass ein Teil der Welt
                        unsicher wird, dann passen wir unser Angebotsportfolio
                        an. Außerdem versuchen wir euch Links und Informationen
                        über euer Reiseziel zu schicken. Allerdings können wir
                        das nicht immer garantieren und ihr müsst euch bitte
                        selber über das Reiseziel informieren und überlegen, ob
                        das Reiseziel wirklich für euch in Frage kommt. Kümmert
                        euch außerdem auch selber darum, dass ihr alle nötigen
                        Reisedokumente und Impfungen habt. Für Schäden oder
                        Verluste bei Reisen können wir nicht haften.
                      </p>
                    </div>

                    <p className="text-sm font-normal leading-8">
                      12.3. Für Informationen zu Visa und Pässen wenden sich
                      Kunden bitte an die jeweilige Botschaft oder das Konsulat
                      für ihre Reisen. Die Anforderungen können sich ändern und
                      Kunden sollten immer vor Abschluss eines Sportvertrages
                      überprüfen, ob die vorhandenen Informationen aktuell sind.
                      moverii übernimmt keine Haftung für den Fall, dass die
                      Fluggesellschaft oder der Flughafen Kunden die Einreise
                      verweigert oder aufgrund fehlender Anforderungen wie
                      Reisepass, Visum oder anderer möglicherweise
                      erforderlicher Dokumente die Einreise in ein Land nicht
                      möglich ist. Dies gilt auch für Länder, die möglicherweise
                      nicht das endgültige Ziel sind, sondern nur Zwischenstopps
                      und schließt jede Situation ein, in der ein Flugzeug
                      anhält, selbst wenn der Kunde im Flugzeug oder am
                      Flughafen bleibt.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      12.4. Kunden müssen ihren Arzt konsultieren, um die
                      notwendigen und empfohlenen Impfungen für die Reise zu
                      erhalten. Dabei sind Kunden vor Antritt der Reise dafür
                      verantwortlich alle empfohlenen Medikamente einzunehmen,
                      die erforderlichen Impfungen zu erhalten, die
                      Einreisebestimmungen für die Gesundheit zu erfüllen und
                      sämtliche für die Reise gegebenen medizinischen Ratschläge
                      zu befolgen.
                    </p>
                  </article>

                  <article
                    id="term13"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      13. Ausschluss fremder AGB, Anwendbares Recht,
                      Gerichtsstand, Erfüllungsort
                    </p>
                    <p className="text-sm font-normal leading-8">
                      13.1. Die Geltung allgemeiner Vertrags- oder
                      Geschäftsbedingungen des Nutzers wird ausdrücklich
                      ausgeschlossen. Dies gilt auch dann, wenn moverii den
                      Bedingungen des Nutzers nicht ausdrücklich widersprochen
                      hat und/oder Leistungen widerspruchslos erbringt.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      13.2. Diese AGB und der darin geregelte Nutzungsvertrag
                      unterliegen dem Recht der Bundesrepublik Deutschland unter
                      Ausschluss des UN-Kaufrechts.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      13.3. Ist der Nutzer ein Kaufmann im Sinne des
                      Handelsrechts, eine juristische Person des öffentlichen
                      Rechts oder ein öffentlich-rechtliches Sondervermögen,
                      dann ist der Sitz von moverii der ausschließliche
                      Gerichtsstand für alle Rechtsstreitigkeiten aus oder im
                      Zusammenhang mit den AGB. Im Übrigen gelten die
                      gesetzlichen Gerichtsstände.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      13.4. Gegenüber Unternehmern im Sinne des § 14 Abs. 1 BGB
                      ist Erfüllungsort der Sitz von moverii.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Es gelten unsere AGBs. Diese AGBs entsprechen deutschem
                        Recht. Der Gerichtsstand für Rechtsstreitigkeiten ist
                        unser Sitz.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term14"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      14. Änderung dieser AGB
                    </p>
                    <p className="text-sm font-normal leading-8">
                      14.1. Änderungen dieser AGB bedürfen der Textform.
                      Nebenabreden bestehen nicht.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      14.2. moverii behält sich das Recht vor, diese AGB
                      jederzeit ohne Nennung von Gründen zu ändern, es sei denn,
                      die Änderung ist für den Nutzer nicht zumutbar. moverii
                      wird den Nutzer über Änderungen der AGB unverzüglich per
                      E-Mail benachrichtigen. Widerspricht der Nutzer der
                      Geltung der geänderten AGB nicht innerhalb einer Frist von
                      vier Wochen nach Empfang der geänderten AGB, gelten die
                      geänderten AGB als vom Nutzer angenommen. moverii wird den
                      Nutzer auf diese Wirkung in der E-Mail gesondert
                      hinweisen.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Alles verändert sich. So kann es auch sein, dass sich
                        unsere AGBs verändern. In diesem Fall sagen wir euch
                        Bescheid und ihr könnt die neuen AGBs ablehnen.
                      </p>
                    </div>
                  </article>

                  <article
                    id="termB"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-4xl font-bold mb-3 capitalize leading-lg">
                      {" "}
                      B. Besondere Bedingungen für die Nutzung der Website
                    </p>
                  </article>

                  <article
                    id="term15"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      15. Einstellung eines Sportangebotes, Mindestinhalt,
                      Änderungsverfahren
                    </p>
                    <p className="text-sm leading-8 font-normal leading-6">
                      15.1. moverii erstellt für den Anbieter auf der Website
                      ein Inserat zum jeweiligen Sportangebot (nachfolgend: „
                      <b>Inserat</b>“). Zur Erstellung eines Inserates müssen
                      Pflichtangaben, insbesondere zur Sportart,
                      Kurzbeschreibung, Unterkunft, Umgebung, Preis,
                      Anforderungen an den Kunden, Fitnesslevel des Kunden und
                      Standort des Sportangebotes vom Anbieter angegeben und
                      bestätigt sowie visuelle Materialien zur Verwendung gemäß
                      Ziffer 5.2. moverii direkt oder indirekt zur Verfügung
                      gestellt werden. Diese und weitere optionale Angaben
                      können in schriftlicher oder mündlicher Kommunikation, in
                      Email Verkehr, über von moverii festgelegte externe
                      Domänen oder direkt über die dafür freigelegten Funktionen
                      auf der Plattform getätigt werden.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      15.2. Der Anbieter hat die Möglichkeit freiwillig weitere
                      Daten (z.B. Qualifikationen und Fortbildungen) anzugeben.
                      Es steht dem Anbieter frei eigene Vertragsbedingungen
                      bereitzustellen, welche in den Sportvertrag einbezogen
                      werden, sofern diese nicht den Bestimmungen dieser AGB
                      zuwiderlaufen. Es steht dem Anbieter insbesondere frei
                      Stornierungs- und Rücktrittsbedingungen zu vereinbaren.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      15.3. moverii bemüht sich, ist jedoch nicht verpflichtet,
                      vom Anbieter zur Verfügung gestellte Informationen auf
                      ihre Richtigkeit oder Vollständigkeit zu prüfen oder zu
                      kontrollieren. Die Pflicht der Überarbeitung, regelmäßigen
                      Überprüfung und Prüfung der Richtigkeit der Angaben im
                      Inserat obliegt dem Anbieter. Die Angaben im Inserat sind
                      ausschlaggebend für die Inhalte des entstehenden
                      Sportvertrages.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      15.4. moverii behält sich das Recht vom Anbieter zur
                      Verfügung gestellte Materialien und Beschreibungen vor
                      oder nach Veröffentlichung des Inserats nach eigenem
                      Ermessen zu ergänzen, zu überarbeiten oder anzupassen.
                      moverii versucht Anbieter über entsprechende Änderungen
                      zeitnah zu informieren. Außerdem behält moverii sich das
                      Recht vor, Profile von Anbietern und Inserate nach eigenem
                      Belieben innerhalb der Plattform hervorzuheben.
                    </p>
                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Erklärungstext: Angebote kommen nicht von irgendwo! Um
                        Angebote abbilden zu können, müssen Anbieter bestimmte
                        Angaben zu der Sportreise machen, zum Beispiel zur
                        Unterkunft, dem Sportprogramm, den Freizeitaktivitäten
                        oder zusätzliche Regelungen. Manche von den Angaben sind
                        notwendig, manche optional. In der Erstellung der
                        Angebote helfen wir natürlich und optimieren eure
                        Angebote kontinuierlich. Wir informieren euch über
                        relevante Änderungen.
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Kunden müssen sich auf die Informationen im Angebot
                        verlassen können, also müssen Anbieter diese immer
                        aktuell halten. Anbieter können ihre Angebote natürlich
                        jederzeit anpassen, dies gilt aber nicht rückwirkend für
                        bestehende Buchungen. Da gelten die Informationen zum
                        Zeitpunkt der Buchung.
                      </p>
                    </div>
                    <p className="text-sm font-normal leading-8">
                      15.5. Nach Einstellung des Inserates auf der Website kann
                      das Inserat nachträglich verändert oder gelöscht werden,
                      solange noch kein Sportvertrag gemäß Ziffer 16 zustande
                      gekommen ist. Die Regelungen des vorstehenden Satzes
                      gelten auch für individuelle Absprachen der Parteien. Das
                      Inserat kann nach Zustandekommen eines Sportvertrages
                      nicht mehr rückwirkend für diesen Sportvertrag verändert
                      oder gelöscht werden, sondern nur für die zukünftige
                      Darstellung auf der moverii Plattform angepasst werden.
                      Aufforderungen zur Änderung an dem Inserat soll der
                      Anbieter per schriftlicher oder mündlicher Kommunikation
                      oder über die dafür freigelegten Funktionen auf der
                      Plattform an moverii mitteilen. moverii bemüht sich diese
                      zeitnah einzupflegen.
                    </p>
                  </article>

                  <article
                    id="term16"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      16. Buchungsprozess, Vertragsschluss des Sportvertrages,
                      moverii als Bote, keine Versicherung
                    </p>
                    <p className="text-sm font-normal leading-8">
                      16.1. Die rechtsverbindliche Einigung zwischen einem
                      Anbieter und einem Kunden über die entgeltliche
                      Durchführung von Sportangeboten gemäß den Angaben im
                      Inserat erfolgt ausschließlich durch Abschluss eines
                      Sportvertrages auf der Website nach Maßgabe der
                      nachfolgenden Bestimmungen und ggf. unter Einbeziehung von
                      ergänzenden Bestimmungen des Anbieters gemäß Ziffer 15.2
                      Satz 2.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      16.2. Der rechtsverbindliche Abschluss des Sportvertrages
                      vollzieht sich bei einer Sofortbuchung wie folgt:
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      a. Das Inserat des Anbieters stellt kein rechtswirksames
                      Angebot, sondern lediglich eine Aufforderung zur Abgabe
                      eines entsprechenden Angebotes (invitatio ad offerendum)
                      dar.
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      b. Der Kunde wählt eines der Sportangebote aus, füllt das
                      Buchungsformular aus und gibt notwendige Daten zur Buchung
                      an.
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      c. Der Kunde bestätigt seine Auswahl durch Anklicken des
                      Buttons „Jetzt Buchen“.
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      d. Der Kunde hat die Möglichkeit seine Daten noch einmal
                      zu prüfen und zu korrigieren. Dazu stellt moverii dem
                      Kunden angemessene, wirksame und zugängliche technische
                      Mittel zur Verfügung mit deren Hilfe der Kunde
                      Eingabefehler vor der verbindlichen Buchung erkennen und
                      berichtigen kann. Der Kunde kann vor dem verbindlichen
                      Absenden der Buchung durch Betätigen der „Zurück“-Taste im
                      Buchungsformular nach Kontrolle seiner Angaben wieder zur
                      Website gelangen, auf der die Angaben des Kunden erfasst
                      werden und Eingabefehler berichtigen bzw. den
                      Buchungsvorgang durch Schließen des Browsers abbrechen.
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      e. Der Kunde unterbreitet dem Anbieter mit Betätigung des
                      Buttons „Jetzt zahlungspflichtig Buchen“ ein
                      rechtsverbindliches Angebot zum Abschluss eines
                      Sportvertrages zu den im Inserat genannten Konditionen.
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      f. moverii nimmt das Angebot des Kunden im Namen und auf
                      Rechnung des Anbieters automatisiert an, wodurch ein
                      rechtswirksamer Sportvertrag zustande kommt.
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      g. Nach Abschluss des Sportvertrages werden dem Anbieter
                      und dem Kunden, zum Zwecke des Nachweises und nicht als
                      Wirksamkeitsvoraussetzung, eine elektronische
                      Zusammenfassung über den auf der Website geschlossenen
                      Sportvertrag in Textform an die im jeweiligen Account
                      hinterlegten E-Mail-Adressen übermittelt.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-normal leading-8">
                        Bei Buchung eines Angebotes kommt ein Vertrag zwischen
                        dem Anbieter der Sportreise und dem Kunden zustande.
                        Inhalt des Vertrages sind die Angaben aus dem Angebot
                        sowie mögliche zusätzliche AGBs des Anbieters. Diese
                        sind im Abschnitt über die Anbieter abgebildet. Für die
                        Durchführung des Vertrages sind allein Anbieter
                        verantwortlich.
                      </p>
                      <p className="text-sm font-normal leading-8">
                        Für die Buchung gibt es zwei Möglichkeiten, die Anbieter
                        anbieten können. Bei einer Direktbuchung können Kunden
                        das Angebot direkt mit der Zahlung rechtsverbindlich
                        buchen. Eine Bestätigung der Verfügbarkeit seitens des
                        Anbieters ist nicht notwendig.
                      </p>
                      <p className="text-sm font-normal leading-8">
                        Bei einer Buchungsanfrage stellen Kunden eine
                        unverbindliche Anfrage für das Angebot. Anbieter sind
                        dazu angehalten Buchungsanfragen innerhalb von 24
                        Stunden zu beantworten. Nach Bestätigung durch den
                        Anbieter haben Kunden 48 Stunden Zeit, um das Angebot
                        rechtsverbindlich zu buchen.
                      </p>

                      <p className="text-sm font-normal leading-8">
                        Ob es sich bei einem Angebot um eine Direktbuchung oder
                        eine Buchungsanfrage handelt erkennst du an dem Text des
                        Buttons auf der Angebotsseite.
                      </p>

                      <p className="text-sm font-normal leading-8">
                        Die gesamte Zahlungsabwicklung läuft über unsere
                        Plattform ab. Außer anderweitig im Angebot
                        ausgeschrieben fallen für Kunden keine zusätzlichen
                        Kosten an.
                      </p>
                    </div>
                    <p className="text-sm font-normal pl-4  leading-8">
                      16.3. Der rechtsverbindliche Abschluss des Sportvertrages
                      vollzieht sich bei einer Annahmebuchung wie folgt:
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      a. Der Anbieter stellt sämtliche notwendigen Inhalte gemäß
                      Ziffer 12.1 in ein Inserat ein. Das Inserat des Anbieters
                      stellt kein rechtswirksames Angebot, sondern lediglich
                      eine Aufforderung zur Abgabe eines entsprechenden
                      Angebotes (invitatio ad offerendum) dar.
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      b. Der Kunde unterbreitet dem Anbieter mit Betätigung des
                      Buttons „Jetzt zahlungspflichtig Buchen“ im Inserat ein
                      rechtsverbindliches Angebot zum Abschluss eines
                      Sportvertrages zu den im Inserat genannten Konditionen.
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      c. Der Anbieter kann nach Zugang des Angebotes, innerhalb
                      eines von moverii vorgegeben Zeitraumes, entscheiden, ob
                      er das Angebot auf Abschluss eines Sportvertrages durch
                      annimmt, wodurch ein rechtswirksamer Sportvertrag zustande
                      kommt.
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      d. Der Anbieter bearbeitet die Angebote der Kunden in der
                      Reihenfolge ihres Eingangs. Der Anbieter wird ab Erreichen
                      der maximalen Teilnehmerzahl für ein Sportangebot die
                      Buchung weiterer Kunde ablehnen.
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      e. Nach Abschluss des Sportvertrages werden dem Anbieter
                      und dem Kunden, zum Zwecke des Nachweises und nicht als
                      Wirksamkeitsvoraussetzung, eine elektronische
                      Zusammenfassung über den auf der Plattform geschlossenen
                      Sportvertrag in Textform an die im jeweiligen Account
                      hinterlegten E-Mail-Adressen übermittelt.
                    </p>
                    <p className="text-sm font-normal pl-4  leading-8">
                      f. Wenn der Anbieter nicht innerhalb des von moverii
                      festgelegten Zeitraumes nach Zugang des Angebotes ein
                      Angebot abgibt, gilt das Angebot als abgelehnt. Ein
                      Sportvertrag kommt in diesem Fall nicht zustande.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      16.4. Der Anbieter verpflichtet sich, über den im Inserat
                      angegebenen Gesamtpreis hinaus keine weiteren Nebenkosten,
                      Gebühren, Provisionen oder ähnliche Forderungen gegenüber
                      dem Kunden geltend zu machen.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      16.5. moverii nimmt im Auftrag des Anbieters und des
                      Kunden die entsprechenden Erklärungen zum Vertragsschluss
                      entgegen und übermittelt diese. moverii handelt dabei als
                      Bote. moverii nimmt keine eigenen Erklärungen zum
                      Abschluss des Sportvertrages vor.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      16.6. moverii stellt keine Versicherung für die Nutzer.
                      Soweit im Zusammenhang mit den Sportangeboten
                      Schadensersatzansprüchen gegen den Anbieter entstehen, ist
                      der Anbieter verpflichtet, für eine ordnungsgemäße
                      Abwicklung und ggfs. einen ausreichenden
                      Versicherungsschutz Sorge zu tragen.
                    </p>
                  </article>

                  <article
                    id="term17"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      17. Buchungspreis und moverii-Gebühr, Umgehung
                    </p>
                    <p className="text-sm font-normal leading-8">
                      17.1. Sowohl die Registrierung auf der Website, wie auch
                      das Einstellen von Inseraten auf der Website, als auch die
                      Einsichtnahme der eingestellten Inserate sind für alle
                      Nutzer kostenfrei.
                    </p>

                    <p className="text-sm leading-8 font-normal leading-6">
                      17.2. Mit Abschluss eines Sportvertrages entsteht ein
                      Anspruch des Anbieters gegen den Kunden auf die Vergütung
                      für das Sportangebot (nachfolgend „<b>Buchungspreis</b>“).
                      Die Höhe des Buchungspreises wird unter Vorbehalt von
                      Ziffer 17.3 ausschließlich durch den Anbieter bestimmt.
                      Für die Leistungen von moverii im Zusammenhang mit der
                      Vermittlung eines Sportvertrages zwischen Anbieter und
                      Kunde erhebt moverii vom Anbieter eine Gebühr (nachfolgend
                      „<b>moverii-Gebühr</b>“). Der Anspruch von moverii auf die
                      moverii-Gebühr entsteht für jeden erfolgreich
                      durchgeführten Vertragsschluss gemäß Ziffer 16.2 und
                      Ziffer 16.3 auf der Website.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      17.3. Anbieter verpflichten sich im Rahmen einer
                      Mindestpreisgarantie für Inserate, die auf der moverii
                      Plattform gelistet und veröffentlicht sind, anderweitig
                      keine niedrigeren Preise anzubieten und erklären
                      ausdrücklich, dass die an moverii kommunizierten, zur
                      Verfügung gestellten oder direkt über die Plattform
                      hochgeladenen Preise die niedrigsten Preise sind, welche
                      der Anbieter für die im Inserat beschriebenen Leistungen
                      darbietet. Bei Verstoß gegen diese Mindestpreisgarantie,
                      behält moverii sich das Recht vor, entsprechende
                      Schadensansprüche beim Anbieter geltend zu machen und den
                      Anbieter von der Nutzung der moverii Plattform
                      auszuschließen.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      17.4. Die Höhe der moverii-Gebühr bestimmt sich nach den
                      Vereinbarungen des Anbieters mit moverii und umfasst einen
                      festgelegten prozentualen Anteil des Buchungspreis. Die
                      moverii-Gebühr bezieht sich auf sämtliche im Buchungspreis
                      enthaltene Leistungen, inklusive Extraleistungen, wie
                      Anschlussübernachtungen, Mahlzeiten, Transfer- und
                      Transportleistungen und Massagen. Ausnahmen zu dieser
                      Regelung müssen explizit und gesondert getroffen werden.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      17.5. Kommt es nach Abschluss eines Sportvertrages später
                      nicht zur Durchführung des Sportangebotes auf Grund von
                      tatsächlichen oder rechtlichen Gründen, entfällt die
                      moverii-Gebühr deshalb nicht. moverii hat die den Nutzern
                      gegenüber obliegende Leistung durch Nachweis der
                      Gelegenheit zum Abschluss eines Sportvertrages erfüllt,
                      durch entsprechende Mitteilung an den Anbieter und Kunden,
                      dass der Sportvertrag zustande gekommen ist.
                    </p>

                    <p className="text-sm leading-8 font-normal leading-6">
                      17.6. Nutzern ist es untersagt, die moverii-Gebühr und die
                      unter Ziffer 18 geregelten Zahlungsmodalitäten zu umgehen.
                      Sollten Nutzer außerhalb der Website einen Sportvertrag in
                      Bezug auf eines auf der Website eingestellten
                      Sportangebotes schließen, welcher über die Website
                      angebahnt wurde (nachfolgend „<b>Umgehung</b>“), so
                      besteht gleichwohl der Anspruch von moverii auf Zahlung
                      der moverii-Gebühr. Diese wird im Falle einer Umgehung von
                      Anbieter und Kunden gesamtschuldnerisch zur Zahlung an
                      moverii geschuldet.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      17.7. Anbieter sind verpflichtet, außerhalb der Website
                      abgeschlossene Sportverträge für eines auf der Website
                      eingestelltes Sportangebot, welches über die Website, sei
                      es über ein Formular, eine E-Mail oder einen Telefonanruf,
                      angebahnt wurde, innerhalb von 7 Tagen offenzulegen. Wenn
                      moverii von sich aus bei dem Anbieter über den möglichen
                      Abschluss eines Sportvertrages nachfragt und auf diese
                      Rückfrage innerhalb von 4 Wochen keine Antwort erhält,
                      dann gilt der Sportvertrag als zustande gekommen und
                      ebenfalls als Umgehung mit einer entsprechenden
                      Zahlungsschuld in Höhe der moverii-Gebühr. moverii behält
                      sich das Recht vor, sowohl beim Endkunden als auch beim
                      Anbieter nachzufragen, ob entsprechende Sportverträge
                      abgeschlossen wurden und eine Umgehung stattgefunden hat.
                      Sollte moverii in diesem Zuge oder anderweitig in
                      Erfahrung bringen, dass ein über die Plattform zustande
                      gekommener Kontakt in einem abgeschlossenen Sportvertrag
                      mündete und der Anbieter es unterlassen hat dies offen zu
                      legen, so ist der Anbieter zu einer Ersatzzahlung in Höhe
                      des Zehnfachen (10x) der eigentlich anfallenden
                      moverii-Gebühr, mindestens aber zu einer Zahlung in Höhe
                      von 500,00 Euro verpflichtet.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      17.8. Der Buchungspreis und die moverii-Gebühr sind -
                      soweit nicht ausdrücklich anderweitig bestimmt - sofort
                      nach Abschluss des Sportvertrages zur Zahlung fällig und
                      nach Maßgabe der vorgegebenen Zahlungsmodalitäten gemäß
                      Ziffer 18 zu begleichen.
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-normal leading-8">
                        Wir arbeiten aus Leidenschaft und Überzeugung. Unsere
                        Mission ist es Anbietern einen guten Zugang zum Markt zu
                        ermöglichen und Kunden zu ihrer perfekten Wunschreise zu
                        verhelfen. Finanzieren müssen wir uns natürlich trotzdem
                        - so funktioniert die Welt.
                      </p>
                      <p className="text-sm font-normal leading-8">
                        Es ist uns jedoch wichtig, dass Kunden auf keinen extra
                        Kosten sitzen bleiben: Immerhin ist es das Schlimmste,
                        wenn die Traumreise gefunden ist und dann bei
                        Reiseantritt zu merken, dass es dieselbe Reise auch
                        günstiger gibt. Deshalb bieten wir eine verbindliche
                        Bestpreisgarantie. Anbieter verpflichten sich, ihre
                        Sportreisen anderswo nicht günstiger anzubieten.
                      </p>
                      <p className="text-sm font-normal leading-8">
                        Wir arbeiten auf Erfolgsbasis. Anbieter zahlen keine
                        Fixkosten oder sonstige Gebühren, um ihre Angebote über
                        unsere Plattform zu vermarkten. Stattdessen zahlen
                        Anbieter nach abgeschlossener Buchung eine Provision.
                        Diese Provision sehen wir wie ein Marketing Anteil, der
                        in das Budget der Reisen einkalkuliert wurde.
                      </p>
                      <p className="text-sm font-normal leading-8">
                        Außerdem unerlässlich für uns ist Vertrauen. Wir freuen
                        uns, wenn Kunden den direkten Zugang zu Anbietern finden
                        und möchten unsere Nutzer nicht kontrollieren. Wenn
                        daraufhin eine Buchung zustande kommt, möchten wir uns
                        einfach darauf verlassen, dass Anbieter uns Bescheid
                        geben und die Provision entrichten. Dieses Vertrauen ist
                        für uns vielmehr wert als irgendwelche Kontrollen oder
                        Strafen und eine Grundbedingungen für jede erfolgreiche
                        Zusammenarbeit.
                      </p>
                    </div>
                  </article>

                  <article
                    id="term18"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      18. Zahlungsmodalitäten
                    </p>
                    <p className="text-sm font-normal leading-8">
                      18.1. Die Zahlung von Buchungspreis und moverii-Gebühr
                      erfolgt ausschließlich nach Maßgabe der Regelungen dieser
                      Ziffer 18. moverii behält sich vor, einzelne Zahlungsarten
                      gegenüber ausgewählten Nutzern auszuschließen, soweit
                      aufgrund begründeter Anhaltspunkte eine Rücklastschrift
                      bzw. Stornierung der Zahlung oder eine unzureichende
                      Deckung des zu belastenden Bankkontos zu befürchten ist.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      18.2. Die moverii-Gebühr und der Buchungspreis sind mit
                      schuldbefreiender Wirkung ausschließlich unter Verwendung
                      der von moverii auf der Website angegeben Zahlungsarten zu
                      leisten. moverii leitet den Buchungspreis nach Abzug der
                      moverii-Gebühr, vorbehaltlich der Regelung nach Ziffer
                      18.3 und Ziffer 18.4, in der Regel am ersten Freitag nach
                      erfolgreichem Eingang des Buchungspreises, spätestens
                      allerdings nach Ablauf eines Monats oder nach Fristen, die
                      der Anbieter gemäß Ziffer 12.2 festgelegt hat, an den
                      Anbieter weiter. Die Auszahlung erfolgen in der lokalen
                      Währung des Anbieters und die Endbeträge werden
                      entsprechend des aktuellen Wechselkurses am Tag der
                      Auszahlung berechnet.
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      a. entweder der Kunde oder der Anbieter einen Konfliktfall
                      gemeldet hat (z.B. bei Streitigkeiten im Zusammenhang mit
                      zu entrichtenden Entgelten sowie Mängeln oder Schäden);
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      b. die vom Kunden geleistete Zahlung durch diesen oder
                      durch Dritte vor der Auszahlung des Buchungspreises an den
                      Anbieter wieder zurückgefordert wird;
                    </p>

                    <div className="my-3 rounded-[1.25rem] bg-[#E1F9FC] py-4 px-5">
                      <p className="text-lg font-semibold leading-8">
                        In anderen Worten:
                      </p>
                      <p className="text-sm font-medium leading-8">
                        Auf unserer Plattform stehen Kunden verschiedene
                        Zahlungsmodalitäten zur Verfügung. Nach erfolgreichem
                        Eingang einer Zahlung und somit Bestätigung der Buchung
                        zahlen wir den Preis abzüglich der Provision an den
                        Anbieter weiter, in der Regel direkt am nächsten
                        Freitag. Bei Verdacht auf Betrug oder ähnliches können
                        wir die Auszahlung bis zur Klärung verzögern - Vorkommen
                        wird das hoffentlich nicht.
                      </p>
                    </div>

                    <p className="text-sm font-normal  leading-8">
                      18.3. moverii ist berechtigt, die Auszahlung des
                      Buchungspreises an den Anbieter zum Schutz der Interessen
                      des Kunden und des Anbieters bis zu 12 Monate lang zu
                      verweigern, soweitg as
                    </p>
                    <p className="text-sm font-normal pl-4 leading-8">
                      c. und solange moverii begründete Anhaltspunkte dafür
                      vorliegen, dass der Sportvertrag zwischen Anbieter und
                      Kunde nur zum Schein oder rechtsmissbräuchlich vereinbart
                      wurde (z.B. bei Anhaltspunkten für einen
                      Versicherungsbetrug).
                    </p>
                    <p className="text-sm font-normal leading-8">
                      18.4. moverii wird in den unter Ziffer 18.3 a bis b
                      genannten Fällen die Auszahlung veranlassen, soweit sowohl
                      der Kunde als auch der Anbieter gegenüber moverii in
                      Textform einer Auszahlung an einen moverii zu benennenden
                      Empfänger zugestimmt haben. Im Übrigen wird moverii eine
                      Auszahlung veranlassen, wenn moverii eine beglaubigte
                      Kopie der vollstreckbaren Ausfertigung einer gerichtlichen
                      Entscheidung oder eines sonstigen Vollstreckungstitels
                      vorgelegt wird. Ungeachtet des Vorstehenden wird moverii
                      eine Auszahlung spätestens nach Ablauf von 12 Monaten ab
                      Vertragsschluss des Sportvertrages veranlassen.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      18.5. Unsere Zahlungen werden von dem
                      Zahlungsdienstleister Mangopay abgewickelt. Die
                      Allgemeinen Geschäftsbedingungen von Mangopay gelten und
                      sind hier abrufbar:{" "}
                      <a
                        href="https://mangopay.com/terms-and-conditions/payment-services"
                        target="_blank"
                        className="!text-blue-600 underline"
                      >
                        Mangopay’s allgemeine Geschätsbedingungen
                      </a>
                      .
                    </p>
                  </article>

                  <article
                    id="term19"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      19. Bestpreisgarantie
                    </p>
                    <p className="text-sm font-normal leading-8">
                      19.1. Wenn Kunden zum Zeitpunkt ihrer Buchung oder bis zum
                      Zeitpunkt der Erfüllung des zustande gekommenen
                      Sportvertrag auf einer anderen Website einen günstigeren
                      Preis für dieselben Leistungen vorbehaltlich der
                      Bestimmungen aus Ziffern 18.2. und 18.3. finden, ist der
                      Kunde dazu berechtigt, moverii mit der Bitte um eine
                      Erstattung des Differenzpreis zu kontaktieren. Die
                      Kontaktaufnahme kann über alle ausgeschriebenen
                      Kommunikationskanäle stattfinden und soll eine
                      Dokumentation des niedriger ausgeschriebenen Preis und der
                      Quelle enthalten. Dieses Angebot muss zum Zeitpunkt der
                      Kontaktaufnahme zur Buchung verfügbar sein. Dies wird von
                      dem Support-Team von moverii festgelegt. Ein Anspruch auf
                      Erstattung des Differenzpreis besteht nur, wenn der
                      Sportvertrag im Sinne von Ziffer 15.2. und 15.3. über die
                      moverii Plattform zustande gekommen ist.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      21.2. moverii ist nicht verpflichtet Streitigkeiten oder
                      Schadensersatzansprüche der Nutzer untereinander zu
                      regeln, oder an deren Beilegung oder Lösung mitzuwirken.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      21.3. Der Nutzer wird ausdrücklich darauf hingewiesen,
                      dass beim Abschluss von Sportverträgen mit Verbrauchern
                      Widerrufsrechte und sonstige Verbraucherschutzrechte in
                      Betracht kommen, hinsichtlich derer er gegebenenfalls
                      seinen Vertragspartner zu belehren hat.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      21.4. Soweit die entgeltliche Durchführung der
                      Sportangebote zu Einkünften des Anbieters führt, die der
                      Besteuerung unterliegen, ist dieser verpflichtet, für eine
                      ordnungsgemäße Versteuerung der Einkünfte Sorge zu tragen.
                    </p>
                  </article>

                  <article
                    id="termC"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-4xl font-bold mb-3 capitalize leading-10">
                      {" "}
                      C. Widerrufsbelehrung
                    </p>
                  </article>

                  <article
                    id="term20"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      Widerrufsrecht
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Du hast das Recht, binnen vierzehn Tagen ohne Angabe von
                      Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist
                      beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      Um dein Widerrufsrecht auszuüben, musst du uns (moverii -
                      Adrian Helbig Daniel Helbig GbR, Schloßstraße 4, 53115
                      Bonn, Deutschland, Tel.: 0151 7037 6939, E-Mail:
                      team@moverii.de) mittels einer eindeutigen Erklärung (z.B.
                      ein mit der Post versandter Brief, oder E-Mail) über
                      deinen Entschluss, diesen Vertrag zu widerrufen,
                      informieren. Du kannst dafür das beigefügte
                      Muster-Widerrufsformular verwenden, das jedoch nicht
                      vorgeschrieben ist.
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Zur Wahrung der Widerrufsfrist reicht es aus, dass du die
                      Mitteilung über die Ausübung des Widerrufsrechts vor
                      Ablauf der Widerrufsfrist absendest.
                    </p>
                  </article>

                  <article
                    id="term20"
                    className="mt-6 flex w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      Folgen des Widerrufs
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Wenn du diesen Vertrag widerrufst, haben wir dir alle
                      Zahlungen, die wir von dir erhalten haben, unverzüglich
                      und spätestens binnen vierzehn Tagen ab dem Tag
                      zurückzuzahlen, an dem die Mitteilung über deinen Widerruf
                      dieses Vertrags bei uns eingegangen ist. Für diese
                      Rückzahlung verwenden wir dasselbe Zahlungsmittel, das du
                      bei der ursprünglichen Transaktion eingesetzt haben, es
                      sei denn, mit dir wurde ausdrücklich etwas anderes
                      vereinbart; in keinem Fall werden dir wegen dieser
                      Rückzahlung Entgelte berechnet.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      Hast du verlangt, dass die Dienstleistungen während der
                      Widerrufsfrist beginnen soll, zum Beispiel, in dem du
                      Einheiten deiner gebuchten Karte bereits verwendet hast,
                      hast du uns einen angemessenen Betrag zu zahlen, der dem
                      Anteil der bis erbrachten Dienstleistungen im Vergleich
                      zum Gesamtumfang der im Vertrag vorgesehenen
                      Dienstleistungen entspricht.
                    </p>
                  </article>

                  <article
                    id="term20"
                    className="mt-6 flex mb-16 w-full flex-col items-start justify-start"
                  >
                    <p className="text-xl font-bold mb-3 capitalize leading-10">
                      Muster-Widerrufsformular
                    </p>
                    <p className="text-sm font-normal leading-8">
                      Wenn du den Vertrag widerrufen willst, dann kannst du
                      diese Vorlage verwenden und sie uns als Formular
                      zuschicken.
                    </p>

                    <p className="text-sm font-normal leading-8">
                      - An
                      <br />
                      moverii - Adrian Helbig Daniel Helbig GbR Castle Street 4
                      <br />
                      53115 Bonn
                      <br />
                      E-mail: team@moverii.de
                      <br />
                      - Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*)
                      abgeschlossenen Vertrag über die Erbringung der folgenden
                      Dienstleistung (*)
                      <br />
                      - Bestellt am (*)
                      <br />
                      - Anschrift des/der Verbraucher(s)
                      <br />
                      - Unterschrift des/der Verbraucher(s) (nur bei Mitteilung
                      auf Papier)
                      <br />
                      - Datum
                      <br />
                      ___________
                      <br />
                      (*) Unzutreffendes streichen.
                      <br />
                      Status: April 2020
                      <br />
                    </p>
                  </article>
                </section>
              </div>
            </main>
          )}
        </div>
      </>
    );
  })
);

TermsPage.Layout = BaseLayout;
export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};

export default TermsPage;
